// Auto-generated — run: node scripts/build-rv2-messages.mjs
export const frMessages = {
  "backoffice.demo.merchantLocation": `Café Atlas · Casablanca`,
  "backoffice.demoView.data": `Données`,
  "backoffice.demoView.firstLogin": `1ʳᵉ connexion`,
  "backoffice.demoView.title": `Vue de démo`,
  "backoffice.header.period": `7 derniers jours ▾`,
  "backoffice.kpi.activeMerchants": `Marchands actifs`,
  "backoffice.kpi.delta.activeMerchants": `↑ 6 ce mois`,
  "backoffice.kpi.delta.redemption": `↑ 3,1 pts`,
  "backoffice.kpi.delta.repeat": `↑ 5 pts`,
  "backoffice.kpi.delta.selfReward": `scans IA`,
  "backoffice.kpi.delta.transactions": `↑ 12,4 %`,
  "backoffice.kpi.redemption": `Taux de rédemption`,
  "backoffice.kpi.repeat": `Clients répétitifs`,
  "backoffice.kpi.selfReward": `Self-Reward`,
  "backoffice.kpi.transactions": `Transactions`,
  "backoffice.sidebar.campaigns": `Campagnes`,
  "backoffice.sidebar.clients": `Clients`,
  "backoffice.sidebar.dashboard": `Tableau de bord`,
  "backoffice.sidebar.rewards": `Récompenses`,
  "backoffice.sidebar.settings": `Paramètres`,
  "backoffice.sidebar.team": `Équipe`,
  "backoffice.table.amount": `Montant`,
  "backoffice.table.client": `Client`,
  "backoffice.table.date": `Date`,
  "backoffice.table.points": `Points`,
  "backoffice.table.recent": `Dernières transactions`,
  "backoffice.table.type": `Type`,
  "backoffice.table.type.purchase": `Achat`,
  "backoffice.table.type.referral": `Parrainage`,
  "backoffice.table.type.reward": `Récompense`,
  "backoffice.table.type.selfReward": `Self-Reward`,
  "backoffice.welcome.cta": `Configurer mon programme →`,
  "backoffice.welcome.steps.points": `Règles de points`,
  "backoffice.welcome.steps.rewards": `Récompenses`,
  "backoffice.welcome.steps.team": `Inviter l'équipe`,
  "backoffice.welcome.subtitle": `Configurez votre premier programme de fidélité en 3 minutes. On vous guide étape par étape.`,
  "backoffice.welcome.title": `Bienvenue chez Popcard Rewards, Café Atlas 👋`,
  "checkout.advisor.noteLabel": `Note de votre conseiller`,
  "checkout.back": `← Retour`,
  "checkout.billing.address": `Adresse *`,
  "checkout.billing.addressPh": `Ex : 12 Boulevard Mohammed V`,
  "checkout.billing.city": `Ville *`,
  "checkout.billing.cityPh": `Ex : Casablanca`,
  "checkout.billing.continue": `Continuer vers la formule →`,
  "checkout.billing.email": `Email *`,
  "checkout.billing.emailPh": `vous@exemple.com`,
  "checkout.billing.entityCompany": `Entreprise`,
  "checkout.billing.entityIndividual": `Particulier`,
  "checkout.billing.entityType": `Souhaitez-vous être facturé en tant qu'entreprise ou particulier ?`,
  "checkout.billing.firstName": `Prénom *`,
  "checkout.billing.ice": `ICE *`,
  "checkout.billing.icePh": `Ex : 001234567000012`,
  "checkout.billing.ifRc": `IF / RC (optionnel)`,
  "checkout.billing.ifRcPh": `Ex : 123456`,
  "checkout.billing.lastName": `Nom *`,
  "checkout.billing.phone": `Téléphone *`,
  "checkout.billing.phonePh": `Ex : 06 12 34 56 78`,
  "checkout.billing.raisonSociale": `Raison sociale *`,
  "checkout.billing.raisonSocialePh": `Popcard`,
  "checkout.billing.saving": `Enregistrement…`,
  "checkout.billing.subtitle": `Ces informations serviront à générer vos factures.`,
  "checkout.billing.title": `Informations de facturation`,
  "checkout.billing.zipCode": `Code postal *`,
  "checkout.billing.zipCodePh": `Ex : 20000`,
  "checkout.continue": `Continuer →`,
  "checkout.cta.requestDemo": `Demander une démo`,
  "checkout.errors.address": `Veuillez indiquer votre adresse.`,
  "checkout.errors.billingSave": `Impossible d'enregistrer la facturation.`,
  "checkout.errors.city": `Veuillez indiquer votre ville.`,
  "checkout.errors.contactSales": `Pour 11 points de vente ou plus, contactez notre équipe commerciale.`,
  "checkout.errors.email": `Veuillez indiquer votre adresse email.`,
  "checkout.errors.emailInvalid": `Adresse email invalide (ex. nom@entreprise.ma).`,
  "checkout.errors.firstName": `Veuillez indiquer votre prénom.`,
  "checkout.errors.formBanner": `Veuillez corriger les champs indiqués ci-dessous.`,
  "checkout.errors.ice": `Veuillez indiquer votre numéro ICE.`,
  "checkout.errors.ifRc": `Veuillez indiquer votre IF / RC.`,
  "checkout.errors.invalidLink": `Lien de checkout invalide. Contactez votre conseiller Popcard.`,
  "checkout.errors.lastName": `Veuillez indiquer votre nom.`,
  "checkout.errors.leadNotFound": `Demande introuvable. Vérifiez le lien reçu de votre conseiller.`,
  "checkout.errors.paymentCancelled": `Paiement annulé. Vous pouvez réessayer.`,
  "checkout.errors.paymentFailed": `Le paiement a échoué. Vous pouvez réessayer.`,
  "checkout.errors.paymentInit": `Le paiement n'a pas pu être initié. Vérifiez la configuration Payzone.`,
  "checkout.errors.paymentPending": `Paiement en cours de confirmation. Rafraîchissez la page dans quelques instants.`,
  "checkout.errors.phone": `Veuillez indiquer votre numéro de téléphone.`,
  "checkout.errors.phoneDigits": `Le numéro ne doit contenir que des chiffres.`,
  "checkout.errors.phoneInvalid": `Numéro de téléphone invalide.`,
  "checkout.errors.planRequired": `Veuillez choisir une formule.`,
  "checkout.errors.planSave": `Impossible d'enregistrer la formule.`,
  "checkout.errors.raisonSociale": `Veuillez indiquer votre raison sociale.`,
  "checkout.errors.zipCode": `Veuillez indiquer votre code postal.`,
  "checkout.hero.default": `Finalisez votre adhésion en suivant les étapes ci-dessous.`,
  "checkout.hero.greeting": `Bonjour {name} 👋 votre démo est validée`,
  "checkout.hero.withAdvisor": `{advisor} a préparé votre offre. Finalisez votre adhésion en suivant les étapes ci-dessous.`,
  "checkout.pay": `🔒 Payer et activer mon compte`,
  "checkout.payAmount": `Payer {amount} MAD →`,
  "checkout.payment.ackRequired": `Cochez la case ci-dessus pour continuer vers la page de paiement.`,
  "checkout.payment.autoRenew.charge": `Le montant indiqué ci-dessus est prélevé automatiquement à chaque échéance, à la date anniversaire.`,
  "checkout.payment.autoRenew.control": `Vous gardez le contrôle : résiliez à tout moment depuis votre back-office — sans frais ni justificatif.`,
  "checkout.payment.autoRenew.partnerPrefix": `La saisie de la carte se fait chez notre partenaire de paiement`,
  "checkout.payment.autoRenew.partnerSuffix": `; Popcard Rewards n'a jamais accès à vos données bancaires.`,
  "checkout.payment.autoRenew.title": `🔁 Abonnement à renouvellement automatique`,
  "checkout.payment.confirm.subtitle": `Vérifiez le récapitulatif, acceptez les conditions, puis validez pour être redirigé vers la page sécurisée de notre partenaire de paiement.`,
  "checkout.payment.confirm.title": `Confirmez votre abonnement`,
  "checkout.payment.confirming": `Confirmation du paiement en cours…`,
  "checkout.payment.installation": `Installation`,
  "checkout.payment.installationFree": `Offerte`,
  "checkout.payment.recap": `RÉCAPITULATIF`,
  "checkout.payment.recurrence": `🔁 Puis {amount} {every}, à partir du {date}. Résiliable à tout moment.`,
  "checkout.payment.redirecting": `Redirection…`,
  "checkout.payment.securedPrefix": `🔒 Sécurisé par`,
  "checkout.payment.securedSuffix": `· facture automatique`,
  "checkout.payment.terms.cgv": `Conditions Générales de Vente`,
  "checkout.payment.terms.mid": `et j'autorise expressément le renouvellement automatique de mon abonnement`,
  "checkout.payment.terms.prefix": `Je reconnais avoir pris connaissance des`,
  "checkout.payment.terms.suffix": `aux conditions indiquées ci-dessus, jusqu'à résiliation.`,
  "checkout.payment.title": `Paiement sécurisé`,
  "checkout.payment.totalToday": `Total aujourd'hui`,
  "checkout.plan.bestOffer": `⭐ Meilleure offre`,
  "checkout.plan.bizLabel": `Type de commerce`,
  "checkout.plan.card.annualBenefit": `✓ 2 mois offerts`,
  "checkout.plan.card.annualSub": `soit {amount} MAD/mois`,
  "checkout.plan.card.monthlyFlex": `Flexibilité totale`,
  "checkout.plan.circuitLabel": `Circuit`,
  "checkout.plan.closedCircuit": `Circuit fermé`,
  "checkout.plan.continuePayment": `Continuer vers le paiement →`,
  "checkout.plan.dueToday": `À régler aujourd'hui (TTC)`,
  "checkout.plan.label.monthly": `mensuel`,
  "checkout.plan.label.yearly": `annuel`,
  "checkout.plan.loading": `Chargement des formules…`,
  "checkout.plan.networkQuote.desc": `Au-delà de 10 points de vente, votre conseiller construit une offre adaptée à votre volume. Le montant exact sera ajouté ici avant paiement.`,
  "checkout.plan.networkQuote.title": `Tarif réseau sur devis`,
  "checkout.plan.offerApplied": `Offre commerciale appliquée sur cette tranche de points de vente.`,
  "checkout.plan.openCircuit": `Circuit ouvert`,
  "checkout.plan.publicPricing": `Tarifs publics pour cette tranche. Revenez à {tier} pour retrouver l'offre négociée.`,
  "checkout.plan.pvEditable": `✓ Modifiable à cette étape`,
  "checkout.plan.pvLabel": `Nombre de points de vente`,
  "checkout.plan.recur.monthly": `chaque mois`,
  "checkout.plan.recur.yearly": `chaque année`,
  "checkout.plan.setupFee": `Frais d'installation`,
  "checkout.plan.setupFree": `Offerts`,
  "checkout.plan.subscription": `Abonnement {plan}`,
  "checkout.plan.subtitle": `Voici l'abonnement que vous avez choisi, ou convenu avec votre conseiller. Vous pouvez le modifier à tout moment.`,
  "checkout.plan.surDevis": `Sur devis`,
  "checkout.plan.title": `Votre formule`,
  "checkout.plan.unit.perMonth": `/mois`,
  "checkout.plan.unit.perYear": `/an`,
  "checkout.steps.access": `Accès`,
  "checkout.steps.billing": `Facturation`,
  "checkout.steps.payment": `Paiement`,
  "checkout.steps.plan": `Formule`,
  "checkout.success.badge": `Paiement confirmé`,
  "checkout.success.cta": `Créer mon accès →`,
  "checkout.success.manageHint": `Vous pouvez gérer ou résilier votre abonnement, et mettre à jour votre carte, à tout moment depuis votre back-office.`,
  "checkout.success.recap.invoiceLabel": `Facture`,
  "checkout.success.recap.invoiceValue": `Disponible dans l'onglet Facturation du back-office`,
  "checkout.success.recap.nextChargeLabel": `Prochain prélèvement`,
  "checkout.success.recap.nextChargeValue": `{amount} le {date}`,
  "checkout.success.recap.planLabel": `Formule`,
  "checkout.success.subtitle": `Il ne reste plus qu'une étape : créer vos identifiants d'accès.`,
  "checkout.success.title": `Votre programme de fidélité est prêt 🚀`,
  "commercants.badge": `Pour les commerçants 🇲🇦`,
  "commercants.biz.label": `🏪 Votre commerce est… *`,
  "commercants.biz.mixte.desc": `Les deux canaux combinés.`,
  "commercants.biz.mixte.title": `Physique + en ligne`,
  "commercants.biz.online.desc": `Shopify, WooCommerce, WordPress…`,
  "commercants.biz.online.title": `Boutique en ligne`,
  "commercants.biz.physique.desc": `Boutique, restaurant, salon…`,
  "commercants.biz.physique.title": `Commerce physique`,
  "commercants.city.empty": `Aucune ville trouvée — appelez-nous, on s'occupe de tout.`,
  "commercants.city.hint": `Choisissez votre ville pour voir les formats de démo disponibles près de chez vous.`,
  "commercants.city.label": `📍 Dans quelle ville ? *`,
  "commercants.city.onsite": `🏬 Sur place`,
  "commercants.city.otherLabel": `Précisez votre ville *`,
  "commercants.city.otherPlaceholder": `Ex : El Jadida`,
  "commercants.city.placeholder": `Rechercher votre ville…`,
  "commercants.confirmation.backHome": `Revenir à l'accueil`,
  "commercants.confirmation.callback": `On vous rappelle en général en moins de 1h ouvrée! ⚡☎️`,
  "commercants.confirmation.card.backoffice.desc": `Votre programme de fidélité est activé immédiatement.`,
  "commercants.confirmation.card.backoffice.title": `Accès backoffice`,
  "commercants.confirmation.card.demo.desc": `On vous présente la solution adaptée à votre commerce.`,
  "commercants.confirmation.card.demo.title": `Démo`,
  "commercants.confirmation.card.payment.desc": `Un lien unique pour régler en ligne en toute confiance.`,
  "commercants.confirmation.card.payment.title": `Paiement sécurisé`,
  "commercants.confirmation.demoMode.online": `🌐 En ligne`,
  "commercants.confirmation.demoMode.place": `🏬 Sur place`,
  "commercants.confirmation.fields.bizType": `Type de commerce`,
  "commercants.confirmation.fields.businessLink": `Lien business`,
  "commercants.confirmation.fields.businessStatus": `Statut de votre business`,
  "commercants.confirmation.fields.city": `Ville`,
  "commercants.confirmation.fields.company": `Entreprise`,
  "commercants.confirmation.fields.email": `Email`,
  "commercants.confirmation.fields.firstName": `Prénom`,
  "commercants.confirmation.fields.lastName": `Nom`,
  "commercants.confirmation.fields.phone": `Téléphone`,
  "commercants.confirmation.fields.plan": `Abonnement souhaité`,
  "commercants.confirmation.fields.pv": `Points de vente`,
  "commercants.confirmation.followUs": `En attendant votre démo, suivez-nous 👀`,
  "commercants.confirmation.journey.step1": `Un conseiller vous contacte pour valider votre démo.`,
  "commercants.confirmation.journey.step2": `Vous choisissez votre formule et votre rythme de facturation.`,
  "commercants.confirmation.journey.step3": `L'onboarding démarre — votre programme est opérationnel.`,
  "commercants.confirmation.journey.steps": `3 étapes`,
  "commercants.confirmation.journey.title": `Et ensuite ?`,
  "commercants.confirmation.newRequest": `Nouvelle demande`,
  "commercants.confirmation.recap": `Récapitulatif`,
  "commercants.confirmation.recapHeader": `Récapitulatif de votre demande`,
  "commercants.confirmation.social": `Découvrez ce qu'on construit au quotidien et les commerces marocains qui fidélisent déjà avec Popcard Rewards.`,
  "commercants.confirmation.socialProof": `+150 commerces déjà conquis · nouveaux témoignages chaque semaine`,
  "commercants.confirmation.subtitle": `Notre équipe revient vers vous sous 24 h pour confirmer votre créneau de démo.`,
  "commercants.confirmation.title": `Votre demande est bien reçue`,
  "commercants.demo.noOnsite.hint": `La démo sur place n'est pas encore disponible à {city}. Pas d'inquiétude — la démo en ligne est tout aussi complète et ne dure que 30 minutes.`,
  "commercants.demo.online.desc": `En visioconférence (Zoom ou Google Meet), depuis votre commerce. Rapide — 30 minutes.`,
  "commercants.demo.online.title": `Démo en ligne`,
  "commercants.demo.onlineOnly.desc": `En visioconférence (Zoom ou Google Meet), depuis votre commerce à {city}. Rapide — 30 minutes.`,
  "commercants.demo.onlineOnly.title": `Démo en ligne`,
  "commercants.demo.onlineShop.hint": `Boutique en ligne : on connecte Popcard Rewards à votre site Shopify, WooCommerce ou WordPress. La démo se fait en visio — rapide et complète, 30 minutes.`,
  "commercants.demo.onsite.badge": `🎉 Démo sur place disponible à {city}`,
  "commercants.demo.place.desc": `Un commercial se déplace dans votre point de vente à {city}.`,
  "commercants.demo.place.title": `Démo sur place`,
  "commercants.demo.subtitle": `Gratuite et sans engagement. Dites-nous d'abord quel type de commerce vous gérez.`,
  "commercants.demo.title": `Réservez votre démo`,
  "commercants.errors.biz": `Veuillez indiquer le type de votre commerce.`,
  "commercants.errors.businessStatus": `Veuillez indiquer le statut de votre business.`,
  "commercants.errors.city": `Veuillez sélectionner votre ville dans la liste plus haut sur la page.`,
  "commercants.errors.cityDetail": `Veuillez préciser votre ville.`,
  "commercants.errors.company": `Veuillez indiquer le nom de votre entreprise.`,
  "commercants.errors.demoMode": `Veuillez choisir un format de démo.`,
  "commercants.errors.email": `Veuillez indiquer votre adresse email.`,
  "commercants.errors.emailInvalid": `Adresse email invalide (ex. nom@entreprise.ma).`,
  "commercants.errors.firstName": `Veuillez indiquer votre prénom.`,
  "commercants.errors.formBanner": `Veuillez corriger les champs indiqués ci-dessous.`,
  "commercants.errors.generic": `Une erreur est survenue. Veuillez réessayer.`,
  "commercants.errors.lastName": `Veuillez indiquer votre nom.`,
  "commercants.errors.phone": `Veuillez indiquer votre numéro de téléphone.`,
  "commercants.errors.phoneDigits": `Le numéro ne doit contenir que des chiffres.`,
  "commercants.errors.phoneInvalid": `Numéro de téléphone invalide.`,
  "commercants.errors.plan": `Veuillez choisir un type d'abonnement.`,
  "commercants.features.communicate.desc": `Envoyez des campagnes ciblées via Popcard Rewards et restez présent auprès de vos clients au bon moment.`,
  "commercants.features.communicate.title": `Communiquez directement`,
  "commercants.features.community.desc": `Lancez des jeux concours, activez le parrainage et transformez vos clients satisfaits en relais de croissance.`,
  "commercants.features.community.title": `Animez votre communauté`,
  "commercants.features.loyalty.desc": `Récompensez chaque achat avec des points, cadeaux ou cashback, et encouragez vos clients à revenir plus souvent.`,
  "commercants.features.loyalty.title": `Fidélisez vos clients`,
  "commercants.features.pilot.desc": `Suivez vos ventes, vos clients fidèles, vos campagnes et les performances de votre programme depuis un back-office complet.`,
  "commercants.features.pilot.title": `Pilotez votre activité`,
  "commercants.features.title": `Découvrez les fonctionnalités de Popcard Rewards`,
  "commercants.form.businessLink": `Lien vers votre business (Web, Page Instagram, ou autre)`,
  "commercants.form.businessLinkPh": `https://…`,
  "commercants.form.businessStatus": `Statut de votre business *`,
  "commercants.form.businessStatus.established": `Établi`,
  "commercants.form.businessStatus.noActivity": `Sans activité existante`,
  "commercants.form.businessStatus.placeholder": `Sélectionnez…`,
  "commercants.form.businessStatus.preLaunch": `En préparation de lancement`,
  "commercants.form.city": `Ville *`,
  "commercants.form.cityPh": `Sélectionnée ci-dessus`,
  "commercants.form.company": `Nom d'entreprise *`,
  "commercants.form.companyPh": `Ex. Café Atlas`,
  "commercants.form.email": `Email *`,
  "commercants.form.emailPh": `vous@entreprise.ma`,
  "commercants.form.firstName": `Prénom *`,
  "commercants.form.firstNamePh": `Ex. Karim`,
  "commercants.form.footer": `Le choix du pack et l'onboarding ne sont accessibles qu'après validation de votre démo par le commercial affecté.`,
  "commercants.form.lastName": `Nom *`,
  "commercants.form.lastNamePh": `Ex. Bennani`,
  "commercants.form.phone": `Téléphone *`,
  "commercants.form.phonePh": `6 00 00 00 00`,
  "commercants.form.plan": `Type d'abonnement souhaité *`,
  "commercants.form.plan.placeholder": `Sélectionnez…`,
  "commercants.form.planAnnuel": `Annuel (économisez 2 mois)`,
  "commercants.form.planMensuel": `Mensuel`,
  "commercants.form.pv": `Nombre de points de vente *`,
  "commercants.form.pv1": `1 point de vente`,
  "commercants.form.pv11": `11 points de vente ou +`,
  "commercants.form.pv23": `2 à 3 points de vente`,
  "commercants.form.pv46": `4 à 6 points de vente`,
  "commercants.form.pv710": `7 à 10 points de vente`,
  "commercants.form.pvWhite": `Sur devis (Marque blanche)`,
  "commercants.form.submit": `Confirmer ma demande de démo`,
  "commercants.form.submitting": `Envoi en cours…`,
  "commercants.next.step1": `Vous réservez votre démo, gratuite et sans engagement.`,
  "commercants.next.step2": `Le commercial affecté valide votre démo et vos besoins.`,
  "commercants.next.step3": `Vous choisissez votre abonnement récurrent, puis l'onboarding démarre.`,
  "commercants.next.title": `Comment se passe la suite ?`,
  "commercants.subtitle": `Une panoplie d'outils à prix réduit pour fidéliser durablement vos clients et accroître vos revenus récurrents.`,
  "commercants.title": `La croissance de votre commerce commence par vos clients.`,
  "creationLogin.advisor.footer": `Aucune action supplémentaire — Abdelouahab revient vers vous.`,
  "creationLogin.advisor.label": `Votre conseiller Popcard Rewards`,
  "creationLogin.advisor.step1": `Il vous appellera pour fixer un rendez-vous en visioconférence.`,
  "creationLogin.advisor.step2": `Ensemble, vous finaliserez l'installation et paramétrerez votre système.`,
  "creationLogin.advisor.step3": `Il formera votre staff à l'utilisation de la solution au quotidien.`,
  "creationLogin.advisor.training.desc": `Dès que vous aurez terminé la création de vos accès, Abdelouahab en sera informé et vous appellera pour convenir d'un rendez-vous.`,
  "creationLogin.advisor.training.title": `Installation & formation du staff`,
  "creationLogin.backToCheckout": `Retour au checkout`,
  "creationLogin.errors.accountExists": `Un compte existe déjà pour cette demande. Connectez-vous au backoffice.`,
  "creationLogin.errors.businessRequired": `Le nom du commerce est obligatoire.`,
  "creationLogin.errors.createFailed": `Impossible de créer le compte.`,
  "creationLogin.errors.handoffFailed": `Compte créé, mais la connexion automatique a échoué. Connectez-vous manuellement au backoffice.`,
  "creationLogin.errors.invalidLink": `Lien invalide. Reprenez depuis l'étape checkout.`,
  "creationLogin.errors.leadNotFound": `Demande introuvable.`,
  "creationLogin.errors.passwordLength": `Le mot de passe doit contenir au moins 8 caractères.`,
  "creationLogin.errors.passwordMismatch": `Les mots de passe ne correspondent pas.`,
  "creationLogin.errors.paymentRequired": `Le paiement doit être confirmé avant de créer votre accès.`,
  "creationLogin.errors.termsRequired": `Vous devez accepter les CGV.`,
  "creationLogin.form.businessName": `Nom du commerce *`,
  "creationLogin.form.businessNameHint": `Ce sera le nom d'affichage de votre commerce à travers Popcard Rewards`,
  "creationLogin.form.businessNamePh": `Ex: Café Atlas`,
  "creationLogin.form.confirmPassword": `Confirmer le mot de passe *`,
  "creationLogin.form.email": `Email *`,
  "creationLogin.form.legalEntity": `Entité légale`,
  "creationLogin.form.password": `Mot de passe *`,
  "creationLogin.form.submitting": `Création en cours…`,
  "creationLogin.form.termsCgv": `CGV`,
  "creationLogin.form.termsPrefix": `J'accepte les`,
  "creationLogin.form.termsSuffix": `et la politique de confidentialité.`,
  "creationLogin.loginBackoffice": `Se connecter au backoffice`,
  "creationLogin.paymentConfirmed": `✓ Paiement confirmé`,
  "creationLogin.selfManage": `Vous gérez vous-même vos identifiants.`,
  "creationLogin.submit.accessBackoffice": `Accéder à mon backoffice →`,
  "creationLogin.subtitle": `Bienvenue chez Popcard Rewards. Il ne reste plus qu'une étape : créer vos identifiants d'accès.`,
  "creationLogin.title": `Créez votre accès`,
  "landing.ambassadors.badge": `PARTENARIAT SUR MESURE`,
  "landing.ambassadors.circuit.desc": `Soyez visible auprès du réseau Popcard Rewards ou proposez une expérience dédiée.`,
  "landing.ambassadors.circuit.title": `Circuit ouvert ou fermé`,
  "landing.ambassadors.nfc.desc": `Un chevalet sur le comptoir, un tap, c'est réglé. Inscription en quelques secondes.`,
  "landing.ambassadors.nfc.title": `Onboarding NFC / QR`,
  "landing.ambassadors.referral.desc": `Vos clients invitent leurs proches depuis leur profil.`,
  "landing.ambassadors.referral.title": `Parrainage simplifié`,
  "landing.ambassadors.subtitle": `On intègre avec vous un système qui fidélise, développe votre clientèle et maximise vos revenus récurrents.`,
  "landing.ambassadors.title": `Vos clients,
vos futurs ambassadeurs`,
  "landing.ambassadors.wallet.desc": `Un espace fidélité dédié pour chaque enseigne, réuni dans un seul profil client.`,
  "landing.ambassadors.wallet.title": `Un wallet par enseigne`,
  "landing.engagement.badge": `✦ Nouveau · Marketing & croissance`,
  "landing.engagement.contests.check1": `Conditions au choix : formulaire, achat, parrainage…`,
  "landing.engagement.contests.check2": `Lots variés : points, cadeaux, réductions, avantages`,
  "landing.engagement.contests.check3": `Suivi des participations, gagnants et performances`,
  "landing.engagement.contests.cta": `Créer un jeu →`,
  "landing.engagement.contests.desc": `Lancez des tirages au sort, des défis et des récompenses instantanées pour dynamiser votre communauté.`,
  "landing.engagement.contests.heading": `Des campagnes interactives en quelques minutes`,
  "landing.engagement.contests.title": `Jeux concours`,
  "landing.engagement.mock.campaignTitle": `Nouvelle campagne WhatsApp`,
  "landing.engagement.mock.contacts": `Contacts`,
  "landing.engagement.mock.contactsCount": `1 240 contacts`,
  "landing.engagement.mock.contestLabel": `JEU CONCOURS`,
  "landing.engagement.mock.contestTitle": `Un dîner pour deux à gagner 🍽️`,
  "landing.engagement.mock.daysLeft": `· 12j restants`,
  "landing.engagement.mock.messagePrefix": `Vous nous manquez ! 🎁 Profitez de`,
  "landing.engagement.mock.messageSuffix": `sur votre prochaine visite chez Café Atlas. À très vite !`,
  "landing.engagement.mock.openRate": `Taux d'ouverture`,
  "landing.engagement.mock.participate": `Je participe`,
  "landing.engagement.mock.pointsOffer": `50 points offerts`,
  "landing.engagement.mock.prize1.label": `Dîner gastronomique pour deux`,
  "landing.engagement.mock.prize1.rank": `1ᵉʳ prix`,
  "landing.engagement.mock.prize2.label": `Brunch pour deux personnes`,
  "landing.engagement.mock.prize2.rank": `2ᵉ prix`,
  "landing.engagement.mock.prize3.label": `100 points de fidélité offerts`,
  "landing.engagement.mock.prize3.rank": `3ᵉ prix`,
  "landing.engagement.mock.prizesTitle": `🎁 LOTS À GAGNER`,
  "landing.engagement.mock.revenue": `générés par les clients revenus`,
  "landing.engagement.mock.scheduled": `Messages programmés depuis le numéro Popcard Rewards ou le vôtre`,
  "landing.engagement.mock.scheduledBadge": `Programmée · Mar 14:00`,
  "landing.engagement.mock.winners": `3 gagnants`,
  "landing.engagement.poweredBy": `powered by`,
  "landing.engagement.subtitle": `Deux nouveaux leviers pilotés depuis votre back-office, sans quitter Popcard Rewards.`,
  "landing.engagement.title": `Animez, engagez, développez votre base client`,
  "landing.engagement.whatsapp.check1": `Ciblage par segment : dormants, VIP, nouveaux…`,
  "landing.engagement.whatsapp.check3": `Suivi des ouvertures, retours et conversions`,
  "landing.engagement.whatsapp.cta": `Programmer une campagne →`,
  "landing.engagement.whatsapp.desc": `Programmez des messages ciblés et automatisez vos relances clients depuis Popcard Rewards.`,
  "landing.engagement.whatsapp.heading": `Adressez toute votre base client en un clic`,
  "landing.engagement.whatsapp.title": `Campagnes WhatsApp`,
  "landing.features.badge": `✦ Propulsé par l'IA`,
  "landing.features.birthday.desc": `Messages et récompenses automatiques.`,
  "landing.features.birthday.title": `Anniversaire & parrainage`,
  "landing.features.google.desc": `L'IA aide à rédiger l'avis et attribue la récompense.`,
  "landing.features.google.title": `Avis Google récompensés`,
  "landing.features.receipt.badge": `🧾 Lecture intelligente du ticket`,
  "landing.features.receipt.desc": `Montant, date et numéro de ticket sont détectés et vérifiés automatiquement en optant pour la zéro saisie manuelle.`,
  "landing.features.receipt.title": `L'IA lit le ticket de caisse`,
  "landing.features.selfReward.desc": `Le client scanne son ticket depuis son profil.`,
  "landing.features.selfReward.title": `Self-Reward`,
  "landing.features.subtitle": `Zéro téléchargement, zéro friction. Tout commence sur WhatsApp.`,
  "landing.features.title": `L'intelligence qui récompense,
automatiquement`,
  "landing.features.whatsapp.desc": `On s'inscrit en un tap sur WhatsApp. L'app ? Elle s'invite d'elle-même, une fois le client accro.`,
  "landing.features.whatsapp.title": `Zéro application`,
  "landing.finalCta.subtitle": `À partir de 250 MAD/mois — activation immédiate, 100 % made in 🇲🇦.`,
  "landing.finalCta.title": `Transformez votre programme
de fidélité en succès !`,
  "landing.hero.badge": `Adoptée par +150 partenaires au Maroc 🇲🇦`,
  "landing.hero.bullet.instantSignup": `Client inscrit instantanément`,
  "landing.hero.bullet.poweredByAi": `Propulsé par l'IA`,
  "landing.hero.bullet.viaWhatsapp": `100 % via WhatsApp`,
  "landing.hero.desc": `Offrez des points de fidélité à vos clients et faites-les revenir plus souvent grâce à une solution 100% marocaine 🇲🇦`,
  "landing.hero.desc.automate": `automatisez`,
  "landing.hero.desc.grow": `augmentez`,
  "landing.hero.desc.retain": `Fidélisez`,
  "landing.hero.desc.suffix": `vos revenus récurrents.`,
  "landing.hero.fromPrice": `À partir de`,
  "landing.hero.perMonth": `/mois`,
  "landing.hero.phone.cardSubtitle": `Présentez votre QR code chez nos partenaires`,
  "landing.hero.phone.cardTitle": `Ma carte de fidélité virtuelle`,
  "landing.hero.phone.myWallets": `Mes Wallets`,
  "landing.hero.phone.pointsBalance": `Solde points`,
  "landing.hero.phone.tag.home": `Maison & Équ…`,
  "landing.hero.phone.tag.leisure": `Loisirs`,
  "landing.hero.phone.tag.wellness": `Bien-être & …`,
  "landing.hero.title1": `Fidélisez vos clients et`,
  "landing.hero.title2": `augmentez vos revenus`,
  "landing.hero.title3": `grâce à Popcard Rewards`,
  "landing.how.subtitle": `Tous les outils dont vous avez besoin pour fidéliser vos clients, sur une seule plateforme.`,
  "landing.how.title": `Il n'a jamais été aussi simple
de fidéliser ses clients 💘`,
  "landing.included.badge": `ET AUSSI, INCLUS`,
  "landing.included.ecom.desc": `Connexion à Shopify, WooCommerce et WordPress.`,
  "landing.included.ecom.title": `Intégration e-commerce`,
  "landing.included.loyalty.desc": `Cashback linéaire, par tranches ou par catégories de produits.`,
  "landing.included.loyalty.title": `Modèles de fidélité`,
  "landing.included.multi.desc": `Pilotez plusieurs points de vente depuis un seul profil entreprise.`,
  "landing.included.multi.title": `Multi-magasins`,
  "landing.included.reports.desc": `Recevez vos indicateurs clés, à la fréquence de votre choix.`,
  "landing.included.reports.title": `Rapports WhatsApp`,
  "landing.receipt.amount": `Montant`,
  "landing.receipt.pointsGranted": `✓ +24 pts attribués`,
  "landing.receipt.ticketNo": `Ticket n°`,
  "landing.reels.aria.next": `Reel suivant`,
  "landing.reels.aria.prev": `Reel précédent`,
  "landing.reels.aria.viewReel": `Voir le reel {handle}`,
  "landing.reels.category.beautyCenter": `Centre de beauté`,
  "landing.reels.category.gameRoom": `Salle de jeu`,
  "landing.reels.category.readyToWear": `Prêt-à-porter`,
  "landing.reels.category.restaurant": `Restaurant`,
  "landing.reels.category.shoes": `Chaussures`,
  "landing.reels.instagram": `Voir sur Instagram →`,
  "landing.reels.subtitle": `Des commerces de tout le Maroc — plus de {count} clients fidélisés.`,
  "landing.reels.title": `Nos partenaires en parlent mieux que nous`,
  "landing.tools.backoffice.desc": `Choisissez le programme de fidélité qui vous ressemble, pilotez ses performances en temps réel et gérez facilement les accès de vos équipes.`,
  "landing.tools.backoffice.title": `Backoffice Manager`,
  "landing.tools.card.desc": `Une carte de fidélité multi-enseignes, accessible en quelques secondes via WhatsApp.`,
  "landing.tools.card.title": `Carte de fidélité virtuelle`,
  "landing.tools.staff.desc": `Votre équipe active des cartes, attribue ou transforme des points, avec une traçabilité totale.`,
  "landing.tools.staff.title": `Application Staff`,
  "landing.tools.support.desc": `Formation, support et stratégies marketing pour fidéliser durablement.`,
  "landing.tools.support.title": `Accompagnement Popcard Rewards`,
  "landing.trust.badge": `Ils nous font confiance`,
  "nav.features": `Fonctionnalités`,
  "nav.getStarted": `Je m'équipe`,
  "nav.howItWorks": `Comment ça marche`,
  "nav.lang.ar": `العربية`,
  "nav.lang.en": `English`,
  "nav.lang.fr": `Français`,
  "nav.menu": `Menu`,
  "nav.popcard": `Popcard`,
  "nav.pricing": `Tarifs`,
  "nav.testimonials": `Témoignages`,
  "pricing.badge": `✦ Tarifs`,
  "pricing.bill.annuel": `Annuel`,
  "pricing.bill.mensuel": `Mensuel`,
  "pricing.bizLabel": `Type de commerce`,
  "pricing.cta.noteActive": `Activation immédiate · aucun frais d'installation`,
  "pricing.cta.noteQuote": `Un conseiller construit votre tarif réseau sur mesure`,
  "pricing.included.ai": `Lecture IA des tickets`,
  "pricing.included.card": `Carte de fidélité connectée`,
  "pricing.included.google": `Avis Google récompensés`,
  "pricing.included.referral": `Parrainage & Anniversaires`,
  "pricing.included.stats": `Backoffice & statistiques en temps réel`,
  "pricing.included.support": `Accompagnement & support dédié`,
  "pricing.included.title": `Tout est inclus`,
  "pricing.included.whatsapp": `Campagnes WhatsApp illimitées`,
  "pricing.note.annuel": `soit {amount} MAD/mois · prélevés en une fois.`,
  "pricing.note.mensuel": `Facturé chaque mois, résiliable à tout moment.`,
  "pricing.pvLabel": `Nombre de points de vente`,
  "pricing.pvTier.11plus": `Sur devis (11+ points de vente)`,
  "pricing.quote": `Sur devis`,
  "pricing.save.annuel": `2 mois offerts · économisez {amount} MAD`,
  "pricing.subtitle": `D'un commerce unique à un réseau de points de vente — choisissez votre palier, puis votre rythme de facturation.`,
  "pricing.title": `Un tarif clair, quelle que soit votre taille`,
  "pricing.trust.instant": `Activation immédiate`,
  "pricing.trust.noCommitment": `Sans engagement`,
  "pricing.trust.noSetup": `Aucun frais d'installation`,
  "pricing.unit.annuel": `MAD TTC / an`,
  "pricing.unit.mensuel": `MAD TTC / mois`,
  "pricing.whitelabel.desc": `Votre enseigne seule dans le wallet du client, sans autres partenaires dans l'annuaire — circuit fermé.`,
  "pricing.whitelabel.title": `Solution en marque blanche`,
  "shared.cta.callAdvisor": `Appeler un conseiller`,
  "shared.cta.chooseOffer": `Choisir cette offre →`,
  "shared.cta.getDemo": `J'obtiens une démo →`,
  "shared.cta.onQuote": `Sur devis →`,
  "shared.cta.requestQuote": `Demander un devis →`,
  "shared.footer.cgv": `CGV`,
  "shared.footer.company": `ENTREPRISE`,
  "shared.footer.contact": `CONTACT`,
  "shared.footer.legal": `Mentions légales`,
  "shared.footer.privacy": `Confidentialité`,
  "shared.footer.product": `PRODUIT`,
  "shared.footer.rights": `© 2025 Popcard. Tous droits réservés.`,
  "shared.footer.tagline": `La 1ʳᵉ carte de fidélité universelle, 100 % made in Maroc 🇲🇦 — sans application.`,
  "shared.loading": `Chargement…`,
  "shared.securePayment": `Paiement sécurisé`,
  "shared.units.pts": `pts`,
} as const;

// Auto-generated — run: node scripts/build-rv2-messages.mjs
export const enMessages = {
  "backoffice.demo.merchantLocation": `Café Atlas · Casablanca`,
  "backoffice.demoView.data": `Data`,
  "backoffice.demoView.firstLogin": `1st login`,
  "backoffice.demoView.title": `Demo view`,
  "backoffice.header.period": `Last 7 days ▾`,
  "backoffice.kpi.activeMerchants": `Active merchants`,
  "backoffice.kpi.delta.activeMerchants": `↑ 6 this month`,
  "backoffice.kpi.delta.redemption": `↑ 3.1 pts`,
  "backoffice.kpi.delta.repeat": `↑ 5 pts`,
  "backoffice.kpi.delta.selfReward": `AI scans`,
  "backoffice.kpi.delta.transactions": `↑ 12.4%`,
  "backoffice.kpi.redemption": `Redemption rate`,
  "backoffice.kpi.repeat": `Repeat customers`,
  "backoffice.kpi.selfReward": `Self-Reward`,
  "backoffice.kpi.transactions": `Transactions`,
  "backoffice.sidebar.campaigns": `Campaigns`,
  "backoffice.sidebar.clients": `Customers`,
  "backoffice.sidebar.dashboard": `Dashboard`,
  "backoffice.sidebar.rewards": `Rewards`,
  "backoffice.sidebar.settings": `Settings`,
  "backoffice.sidebar.team": `Team`,
  "backoffice.table.amount": `Amount`,
  "backoffice.table.client": `Customer`,
  "backoffice.table.date": `Date`,
  "backoffice.table.points": `Points`,
  "backoffice.table.recent": `Recent transactions`,
  "backoffice.table.type": `Type`,
  "backoffice.table.type.purchase": `Purchase`,
  "backoffice.table.type.referral": `Referral`,
  "backoffice.table.type.reward": `Reward`,
  "backoffice.table.type.selfReward": `Self-Reward`,
  "backoffice.welcome.cta": `Set up my program →`,
  "backoffice.welcome.steps.points": `Points rules`,
  "backoffice.welcome.steps.rewards": `Rewards`,
  "backoffice.welcome.steps.team": `Invite the team`,
  "backoffice.welcome.subtitle": `Set up your first loyalty program in 3 minutes. We guide you step by step.`,
  "backoffice.welcome.title": `Welcome to Popcard Rewards, Café Atlas 👋`,
  "checkout.advisor.noteLabel": `Note from your advisor`,
  "checkout.back": `← Back`,
  "checkout.billing.address": `Address *`,
  "checkout.billing.addressPh": `Ex: 12 Boulevard Mohammed V`,
  "checkout.billing.city": `City *`,
  "checkout.billing.cityPh": `Ex: Casablanca`,
  "checkout.billing.continue": `Continue to plan →`,
  "checkout.billing.email": `Email *`,
  "checkout.billing.emailPh": `you@example.com`,
  "checkout.billing.entityCompany": `Company`,
  "checkout.billing.entityIndividual": `Individual`,
  "checkout.billing.entityType": `Would you like to be invoiced as a company or as an individual?`,
  "checkout.billing.firstName": `First name *`,
  "checkout.billing.ice": `ICE *`,
  "checkout.billing.icePh": `Ex: 001234567000012`,
  "checkout.billing.ifRc": `Tax ID / Trade Reg. (optional)`,
  "checkout.billing.ifRcPh": `Ex: 123456`,
  "checkout.billing.lastName": `Last name *`,
  "checkout.billing.phone": `Phone *`,
  "checkout.billing.phonePh": `Ex: 06 12 34 56 78`,
  "checkout.billing.raisonSociale": `Legal name *`,
  "checkout.billing.raisonSocialePh": `Popcard`,
  "checkout.billing.saving": `Saving…`,
  "checkout.billing.subtitle": `This information is used to generate your invoices.`,
  "checkout.billing.title": `Billing information`,
  "checkout.billing.zipCode": `Postal code *`,
  "checkout.billing.zipCodePh": `Ex: 20000`,
  "checkout.continue": `Continue →`,
  "checkout.cta.requestDemo": `Request a demo`,
  "checkout.errors.address": `Please enter your address.`,
  "checkout.errors.billingSave": `Unable to save billing information.`,
  "checkout.errors.city": `Please enter your city.`,
  "checkout.errors.contactSales": `For 11 outlets or more, contact our sales team.`,
  "checkout.errors.email": `Please enter your email address.`,
  "checkout.errors.emailInvalid": `Invalid email address (e.g. name@company.com).`,
  "checkout.errors.firstName": `Please enter your first name.`,
  "checkout.errors.formBanner": `Please correct the fields indicated below.`,
  "checkout.errors.ice": `Please enter your ICE number.`,
  "checkout.errors.ifRc": `Please enter your tax ID / trade registration.`,
  "checkout.errors.invalidLink": `Invalid checkout link. Contact your Popcard advisor.`,
  "checkout.errors.lastName": `Please enter your last name.`,
  "checkout.errors.leadNotFound": `Request not found. Check the link from your advisor.`,
  "checkout.errors.paymentCancelled": `Payment cancelled. You can try again.`,
  "checkout.errors.paymentFailed": `Payment failed. You can try again.`,
  "checkout.errors.paymentInit": `Payment could not be initiated. Check Payzone configuration.`,
  "checkout.errors.paymentPending": `Payment pending confirmation. Refresh the page in a moment.`,
  "checkout.errors.phone": `Please enter your phone number.`,
  "checkout.errors.phoneDigits": `The number must contain digits only.`,
  "checkout.errors.phoneInvalid": `Invalid phone number.`,
  "checkout.errors.planRequired": `Please choose a plan.`,
  "checkout.errors.planSave": `Unable to save plan.`,
  "checkout.errors.raisonSociale": `Please enter your legal name.`,
  "checkout.errors.zipCode": `Please enter your postal code.`,
  "checkout.hero.default": `Complete your sign-up by following the steps below.`,
  "checkout.hero.greeting": `Hi {name} 👋 your demo is validated`,
  "checkout.hero.withAdvisor": `{advisor} prepared your offer. Complete your sign-up by following the steps below.`,
  "checkout.pay": `🔒 Pay and activate my account`,
  "checkout.payAmount": `Pay {amount} MAD →`,
  "checkout.payment.ackRequired": `Check the box above to continue to the payment page.`,
  "checkout.payment.autoRenew.charge": `The amount shown above is charged automatically at each due date, on the anniversary date.`,
  "checkout.payment.autoRenew.control": `You stay in control: cancel anytime from your back-office — no fee, no justification.`,
  "checkout.payment.autoRenew.partnerPrefix": `The card is entered with our payment partner`,
  "checkout.payment.autoRenew.partnerSuffix": `; Popcard Rewards never has access to your bank details.`,
  "checkout.payment.autoRenew.title": `🔁 Auto-renewing subscription`,
  "checkout.payment.confirm.subtitle": `Review the summary, accept the terms, then confirm to be redirected to our payment partner's secure page.`,
  "checkout.payment.confirm.title": `Confirm your subscription`,
  "checkout.payment.confirming": `Confirming payment…`,
  "checkout.payment.installation": `Setup`,
  "checkout.payment.installationFree": `Free`,
  "checkout.payment.recap": `SUMMARY`,
  "checkout.payment.recurrence": `🔁 Then {amount} {every}, from {date}. Cancel anytime.`,
  "checkout.payment.redirecting": `Redirecting…`,
  "checkout.payment.securedPrefix": `🔒 Secured by`,
  "checkout.payment.securedSuffix": `· automatic invoice`,
  "checkout.payment.terms.cgv": `Terms and Conditions of Sale`,
  "checkout.payment.terms.mid": `and I expressly authorize the automatic renewal of my subscription`,
  "checkout.payment.terms.prefix": `I acknowledge having read the`,
  "checkout.payment.terms.suffix": `under the conditions indicated above, until cancellation.`,
  "checkout.payment.title": `Secure payment`,
  "checkout.payment.totalToday": `Total today`,
  "checkout.plan.bestOffer": `⭐ Best value`,
  "checkout.plan.bizLabel": `Business type`,
  "checkout.plan.card.annualBenefit": `✓ 2 months free`,
  "checkout.plan.card.annualSub": `i.e. {amount} MAD/month`,
  "checkout.plan.card.monthlyFlex": `Full flexibility`,
  "checkout.plan.circuitLabel": `Loop`,
  "checkout.plan.closedCircuit": `Closed loop`,
  "checkout.plan.continuePayment": `Continue to payment →`,
  "checkout.plan.dueToday": `Due today (incl. tax)`,
  "checkout.plan.label.monthly": `monthly`,
  "checkout.plan.label.yearly": `annual`,
  "checkout.plan.loading": `Loading plans…`,
  "checkout.plan.networkQuote.desc": `Beyond 10 outlets, your advisor builds an offer tailored to your volume. The exact amount will be added here before payment.`,
  "checkout.plan.networkQuote.title": `Network pricing on quote`,
  "checkout.plan.offerApplied": `Commercial offer applied for this outlet tier.`,
  "checkout.plan.openCircuit": `Open loop`,
  "checkout.plan.publicPricing": `Public pricing for this tier. Return to {tier} to find the negotiated offer.`,
  "checkout.plan.pvEditable": `✓ Editable at this step`,
  "checkout.plan.pvLabel": `Number of outlets`,
  "checkout.plan.recur.monthly": `every month`,
  "checkout.plan.recur.yearly": `every year`,
  "checkout.plan.setupFee": `Setup fee`,
  "checkout.plan.setupFree": `Free`,
  "checkout.plan.subscription": `Subscription {plan}`,
  "checkout.plan.subtitle": `This is the plan you chose, or agreed on with your advisor. You can change it at any time.`,
  "checkout.plan.surDevis": `On quote`,
  "checkout.plan.title": `Your plan`,
  "checkout.plan.unit.perMonth": `/mo`,
  "checkout.plan.unit.perYear": `/yr`,
  "checkout.steps.access": `Access`,
  "checkout.steps.billing": `Billing`,
  "checkout.steps.payment": `Payment`,
  "checkout.steps.plan": `Plan`,
  "checkout.success.badge": `Payment confirmed`,
  "checkout.success.cta": `Create my access →`,
  "checkout.success.manageHint": `You can manage or cancel your subscription and update your card at any time from your back-office.`,
  "checkout.success.recap.invoiceLabel": `Invoice`,
  "checkout.success.recap.invoiceValue": `Available in the Billing tab of the back-office`,
  "checkout.success.recap.nextChargeLabel": `Next charge`,
  "checkout.success.recap.nextChargeValue": `{amount} on {date}`,
  "checkout.success.recap.planLabel": `Plan`,
  "checkout.success.subtitle": `Just one step left: create your login credentials.`,
  "checkout.success.title": `Your loyalty program is ready 🚀`,
  "commercants.badge": `For merchants 🇲🇦`,
  "commercants.biz.label": `🏪 Your business is… *`,
  "commercants.biz.mixte.desc": `Both channels combined.`,
  "commercants.biz.mixte.title": `Physical + online`,
  "commercants.biz.online.desc": `Shopify, WooCommerce, WordPress…`,
  "commercants.biz.online.title": `Online store`,
  "commercants.biz.physique.desc": `Shop, restaurant, salon…`,
  "commercants.biz.physique.title": `Physical store`,
  "commercants.city.empty": `No city found — call us, we'll take care of everything.`,
  "commercants.city.hint": `Choose your city to see the demo formats available near you.`,
  "commercants.city.label": `📍 Which city? *`,
  "commercants.city.onsite": `🏬 On site`,
  "commercants.city.otherLabel": `Specify your city *`,
  "commercants.city.otherPlaceholder": `E.g. El Jadida`,
  "commercants.city.placeholder": `Search for your city…`,
  "commercants.confirmation.backHome": `Back to home`,
  "commercants.confirmation.callback": `We usually call back within 1 business hour! ⚡☎️`,
  "commercants.confirmation.card.backoffice.desc": `Your loyalty program is activated instantly.`,
  "commercants.confirmation.card.backoffice.title": `Back-office access`,
  "commercants.confirmation.card.demo.desc": `We present the solution tailored to your business.`,
  "commercants.confirmation.card.demo.title": `Demo`,
  "commercants.confirmation.card.payment.desc": `A single link to pay online with confidence.`,
  "commercants.confirmation.card.payment.title": `Secure payment`,
  "commercants.confirmation.demoMode.online": `Online demo`,
  "commercants.confirmation.demoMode.place": `On-site demo`,
  "commercants.confirmation.fields.bizType": `Business type`,
  "commercants.confirmation.fields.businessLink": `Business link`,
  "commercants.confirmation.fields.businessStatus": `Business status`,
  "commercants.confirmation.fields.city": `City`,
  "commercants.confirmation.fields.company": `Company`,
  "commercants.confirmation.fields.email": `Email`,
  "commercants.confirmation.fields.firstName": `First name`,
  "commercants.confirmation.fields.lastName": `Last name`,
  "commercants.confirmation.fields.phone": `Phone`,
  "commercants.confirmation.fields.plan": `Preferred plan`,
  "commercants.confirmation.fields.pv": `Outlets`,
  "commercants.confirmation.followUs": `While you wait for your demo, follow us 👀`,
  "commercants.confirmation.journey.step1": `An advisor contacts you to validate your demo.`,
  "commercants.confirmation.journey.step2": `You choose your plan and billing rhythm.`,
  "commercants.confirmation.journey.step3": `Onboarding begins — your program goes live.`,
  "commercants.confirmation.journey.steps": `3 steps`,
  "commercants.confirmation.journey.title": `What's next?`,
  "commercants.confirmation.newRequest": `New request`,
  "commercants.confirmation.recap": `Summary`,
  "commercants.confirmation.recapHeader": `Summary of your request`,
  "commercants.confirmation.social": `Discover what we build every day and the Moroccan businesses already building loyalty with Popcard Rewards.`,
  "commercants.confirmation.socialProof": `+150 businesses already won over · new testimonials every week`,
  "commercants.confirmation.subtitle": `Our team will get back to you within 24 h to confirm your demo slot.`,
  "commercants.confirmation.title": `Your request has been received`,
  "commercants.demo.noOnsite.hint": `On-site demo isn't available in {city} yet. No worries — the online demo is just as complete and only takes 30 minutes.`,
  "commercants.demo.online.desc": `By video call (Zoom or Google Meet), from your business. Quick — 30 minutes.`,
  "commercants.demo.online.title": `Online demo`,
  "commercants.demo.onlineOnly.desc": `By video call (Zoom or Google Meet), from your business in {city}. Quick — 30 minutes.`,
  "commercants.demo.onlineOnly.title": `Online demo`,
  "commercants.demo.onlineShop.hint": `Online store: we connect Popcard Rewards to your Shopify, WooCommerce or WordPress site. The demo is by video call — quick and complete, 30 minutes.`,
  "commercants.demo.onsite.badge": `🎉 On-site demo available in {city}`,
  "commercants.demo.place.desc": `A rep visits your outlet in {city}.`,
  "commercants.demo.place.title": `On-site demo`,
  "commercants.demo.subtitle": `Free and with no commitment. First, tell us what kind of business you run.`,
  "commercants.demo.title": `Book your demo`,
  "commercants.errors.biz": `Please indicate your business type.`,
  "commercants.errors.businessStatus": `Please indicate your business status.`,
  "commercants.errors.city": `Please select your city from the list higher up on the page.`,
  "commercants.errors.cityDetail": `Please specify your city.`,
  "commercants.errors.company": `Please enter your company name.`,
  "commercants.errors.demoMode": `Please choose a demo format.`,
  "commercants.errors.email": `Please enter your email address.`,
  "commercants.errors.emailInvalid": `Invalid email address (e.g. name@company.com).`,
  "commercants.errors.firstName": `Please enter your first name.`,
  "commercants.errors.formBanner": `Please correct the fields indicated below.`,
  "commercants.errors.generic": `Something went wrong. Please try again.`,
  "commercants.errors.lastName": `Please enter your last name.`,
  "commercants.errors.phone": `Please enter your phone number.`,
  "commercants.errors.phoneDigits": `The number must contain digits only.`,
  "commercants.errors.phoneInvalid": `Invalid phone number.`,
  "commercants.errors.plan": `Please choose a subscription type.`,
  "commercants.features.communicate.desc": `Send targeted campaigns via Popcard Rewards and stay present with your customers at the right moment.`,
  "commercants.features.communicate.title": `Communicate directly`,
  "commercants.features.community.desc": `Run contests, activate referrals and turn your happy customers into growth drivers.`,
  "commercants.features.community.title": `Engage your community`,
  "commercants.features.loyalty.desc": `Reward every purchase with points, gifts or cashback, and encourage your customers to come back more often.`,
  "commercants.features.loyalty.title": `Build customer loyalty`,
  "commercants.features.pilot.desc": `Track your sales, loyal customers, campaigns and program performance from a complete back-office.`,
  "commercants.features.pilot.title": `Steer your business`,
  "commercants.features.title": `Discover Popcard Rewards features`,
  "commercants.form.businessLink": `Link to your business (website, Instagram page, or other)`,
  "commercants.form.businessLinkPh": `https://…`,
  "commercants.form.businessStatus": `Business status *`,
  "commercants.form.businessStatus.established": `Established`,
  "commercants.form.businessStatus.noActivity": `No existing activity`,
  "commercants.form.businessStatus.placeholder": `Select…`,
  "commercants.form.businessStatus.preLaunch": `Preparing to launch`,
  "commercants.form.city": `City *`,
  "commercants.form.cityPh": `Selected above`,
  "commercants.form.company": `Company name *`,
  "commercants.form.companyPh": `Ex. Café Atlas`,
  "commercants.form.email": `Email *`,
  "commercants.form.emailPh": `you@company.ma`,
  "commercants.form.firstName": `First name *`,
  "commercants.form.firstNamePh": `Ex. Karim`,
  "commercants.form.footer": `Plan selection and onboarding are only available after your demo is validated by the assigned rep.`,
  "commercants.form.lastName": `Last name *`,
  "commercants.form.lastNamePh": `Ex. Bennani`,
  "commercants.form.phone": `Phone *`,
  "commercants.form.phonePh": `6 00 00 00 00`,
  "commercants.form.plan": `Preferred subscription *`,
  "commercants.form.plan.placeholder": `Select…`,
  "commercants.form.planAnnuel": `Yearly (save 2 months)`,
  "commercants.form.planMensuel": `Monthly`,
  "commercants.form.pv": `Number of outlets *`,
  "commercants.form.pv1": `1 outlet`,
  "commercants.form.pv11": `11 outlets or more`,
  "commercants.form.pv23": `2 to 3 outlets`,
  "commercants.form.pv46": `4 to 6 outlets`,
  "commercants.form.pv710": `7 to 10 outlets`,
  "commercants.form.pvWhite": `On quote (White label)`,
  "commercants.form.submit": `Confirm my demo request`,
  "commercants.form.submitting": `Sending…`,
  "commercants.next.step1": `You book your demo, free and with no commitment.`,
  "commercants.next.step2": `The assigned rep validates your demo and your needs.`,
  "commercants.next.step3": `You choose your recurring plan, then onboarding begins.`,
  "commercants.next.title": `What happens next?`,
  "commercants.subtitle": `A full toolkit at a low price to build lasting customer loyalty and grow your recurring revenue.`,
  "commercants.title": `Your business growth starts with your customers.`,
  "creationLogin.advisor.footer": `No further action — Abdelouahab will get back to you.`,
  "creationLogin.advisor.label": `Your Popcard Rewards advisor`,
  "creationLogin.advisor.step1": `He will call you to set up a video call appointment.`,
  "creationLogin.advisor.step2": `Together, you'll finalize setup and configure your system.`,
  "creationLogin.advisor.step3": `He will train your staff to use the solution day to day.`,
  "creationLogin.advisor.training.desc": `Once you finish creating your access, Abdelouahab will be notified and will call you to arrange an appointment.`,
  "creationLogin.advisor.training.title": `Setup & staff training`,
  "creationLogin.backToCheckout": `Back to checkout`,
  "creationLogin.errors.accountExists": `An account already exists for this request. Log in to the back-office.`,
  "creationLogin.errors.businessRequired": `Business name is required.`,
  "creationLogin.errors.createFailed": `Unable to create account.`,
  "creationLogin.errors.handoffFailed": `Account created, but automatic login failed. Log in manually to the back-office.`,
  "creationLogin.errors.invalidLink": `Invalid link. Return from the checkout step.`,
  "creationLogin.errors.leadNotFound": `Request not found.`,
  "creationLogin.errors.passwordLength": `Password must be at least 8 characters.`,
  "creationLogin.errors.passwordMismatch": `Passwords do not match.`,
  "creationLogin.errors.paymentRequired": `Payment must be confirmed before creating your access.`,
  "creationLogin.errors.termsRequired": `You must accept the Terms of Sale.`,
  "creationLogin.form.businessName": `Business name *`,
  "creationLogin.form.businessNameHint": `This will be the display name of your business across Popcard Rewards`,
  "creationLogin.form.businessNamePh": `Ex: Café Atlas`,
  "creationLogin.form.confirmPassword": `Confirm password *`,
  "creationLogin.form.email": `Email *`,
  "creationLogin.form.legalEntity": `Legal entity`,
  "creationLogin.form.password": `Password *`,
  "creationLogin.form.submitting": `Creating…`,
  "creationLogin.form.termsCgv": `Terms`,
  "creationLogin.form.termsPrefix": `I accept the`,
  "creationLogin.form.termsSuffix": `and the privacy policy.`,
  "creationLogin.loginBackoffice": `Log in to the back-office`,
  "creationLogin.paymentConfirmed": `✓ Payment confirmed`,
  "creationLogin.selfManage": `You manage your own credentials.`,
  "creationLogin.submit.accessBackoffice": `Go to my back-office →`,
  "creationLogin.subtitle": `Welcome to Popcard Rewards. Just one step left: create your login credentials.`,
  "creationLogin.title": `Create your access`,
  "landing.ambassadors.badge": `TAILORED PARTNERSHIP`,
  "landing.ambassadors.circuit.desc": `Be visible to the Popcard Rewards network or offer a dedicated experience.`,
  "landing.ambassadors.circuit.title": `Open or closed loop`,
  "landing.ambassadors.nfc.desc": `A stand on the counter, one tap, done. Sign-up in seconds.`,
  "landing.ambassadors.nfc.title": `NFC / QR onboarding`,
  "landing.ambassadors.referral.desc": `Your customers invite their friends from their profile.`,
  "landing.ambassadors.referral.title": `Simplified referrals`,
  "landing.ambassadors.subtitle": `Together we set up a system that builds loyalty, grows your customer base and maximizes your recurring revenue.`,
  "landing.ambassadors.title": `Your customers,
your future ambassadors`,
  "landing.ambassadors.wallet.desc": `A dedicated loyalty space for each brand, gathered in a single customer profile.`,
  "landing.ambassadors.wallet.title": `One wallet per brand`,
  "landing.engagement.badge": `✦ New · Marketing & growth`,
  "landing.engagement.contests.check1": `Conditions of your choice: form, purchase, referral…`,
  "landing.engagement.contests.check2": `Varied prizes: points, gifts, discounts, perks`,
  "landing.engagement.contests.check3": `Track entries, winners and performance`,
  "landing.engagement.contests.cta": `Create a game →`,
  "landing.engagement.contests.desc": `Run prize draws, challenges and instant rewards to energize your community.`,
  "landing.engagement.contests.heading": `Interactive campaigns in minutes`,
  "landing.engagement.contests.title": `Contests`,
  "landing.engagement.mock.campaignTitle": `New WhatsApp campaign`,
  "landing.engagement.mock.contacts": `Contacts`,
  "landing.engagement.mock.contactsCount": `1,240 contacts`,
  "landing.engagement.mock.contestLabel": `CONTEST`,
  "landing.engagement.mock.contestTitle": `Win a dinner for two 🍽️`,
  "landing.engagement.mock.daysLeft": `· 12 days left`,
  "landing.engagement.mock.messagePrefix": `We miss you! 🎁 Enjoy`,
  "landing.engagement.mock.messageSuffix": `on your next visit to Café Atlas. See you soon!`,
  "landing.engagement.mock.openRate": `Open rate`,
  "landing.engagement.mock.participate": `Enter now`,
  "landing.engagement.mock.pointsOffer": `50 free points`,
  "landing.engagement.mock.prize1.label": `Fine dining for two`,
  "landing.engagement.mock.prize1.rank": `1st prize`,
  "landing.engagement.mock.prize2.label": `Brunch for two`,
  "landing.engagement.mock.prize2.rank": `2nd prize`,
  "landing.engagement.mock.prize3.label": `100 loyalty points free`,
  "landing.engagement.mock.prize3.rank": `3rd prize`,
  "landing.engagement.mock.prizesTitle": `🎁 PRIZES TO WIN`,
  "landing.engagement.mock.revenue": `generated by returning customers`,
  "landing.engagement.mock.scheduled": `Messages scheduled from the Popcard Rewards number or your own`,
  "landing.engagement.mock.scheduledBadge": `Scheduled · Tue 2:00 PM`,
  "landing.engagement.mock.winners": `3 winners`,
  "landing.engagement.poweredBy": `powered by`,
  "landing.engagement.subtitle": `Two new levers driven from your back-office, without leaving Popcard Rewards.`,
  "landing.engagement.title": `Engage, activate, grow your customer base`,
  "landing.engagement.whatsapp.check1": `Segment targeting: dormant, VIP, new…`,
  "landing.engagement.whatsapp.check3": `Track opens, replies and conversions`,
  "landing.engagement.whatsapp.cta": `Schedule a campaign →`,
  "landing.engagement.whatsapp.desc": `Schedule targeted messages and automate customer follow-ups from Popcard Rewards.`,
  "landing.engagement.whatsapp.heading": `Reach your whole customer base in one click`,
  "landing.engagement.whatsapp.title": `Campaigns WhatsApp`,
  "landing.features.badge": `✦ Powered by AI`,
  "landing.features.birthday.desc": `Automatic messages and rewards.`,
  "landing.features.birthday.title": `Birthday & referral`,
  "landing.features.google.desc": `AI helps write the review and grants the reward.`,
  "landing.features.google.title": `Rewarded Google reviews`,
  "landing.features.receipt.badge": `🧾 Smart receipt scanning`,
  "landing.features.receipt.desc": `Amount, date and receipt number are detected and verified automatically with zero manual entry.`,
  "landing.features.receipt.title": `AI reads the receipt`,
  "landing.features.selfReward.desc": `The customer scans their receipt from their profile.`,
  "landing.features.selfReward.title": `Self-Reward`,
  "landing.features.subtitle": `Zero download, zero friction. Everything starts on WhatsApp.`,
  "landing.features.title": `The intelligence that rewards,
automatically`,
  "landing.features.whatsapp.desc": `Sign up in one tap on WhatsApp. The app? It shows up on its own, once the customer is hooked.`,
  "landing.features.whatsapp.title": `Zero app`,
  "landing.finalCta.subtitle": `From 250 MAD/month — instant activation, 100% made in 🇲🇦.`,
  "landing.finalCta.title": `Turn your loyalty program
into a success!`,
  "landing.hero.badge": `Adopted by +150 partners in Morocco 🇲🇦`,
  "landing.hero.bullet.instantSignup": `Customer signed up instantly`,
  "landing.hero.bullet.poweredByAi": `Powered by AI`,
  "landing.hero.bullet.viaWhatsapp": `100% via WhatsApp`,
  "landing.hero.desc": `Give your customers loyalty points and bring them back more often with a 100% Moroccan solution 🇲🇦`,
  "landing.hero.desc.automate": `automate`,
  "landing.hero.desc.grow": `grow`,
  "landing.hero.desc.retain": `Retain`,
  "landing.hero.desc.suffix": `your recurring revenue.`,
  "landing.hero.fromPrice": `From`,
  "landing.hero.perMonth": `/month`,
  "landing.hero.phone.cardSubtitle": `Show your QR code at our partners`,
  "landing.hero.phone.cardTitle": `My virtual loyalty card`,
  "landing.hero.phone.myWallets": `My Wallets`,
  "landing.hero.phone.pointsBalance": `Points balance`,
  "landing.hero.phone.tag.home": `Home & Equ…`,
  "landing.hero.phone.tag.leisure": `Leisure`,
  "landing.hero.phone.tag.wellness": `Wellness & …`,
  "landing.hero.title1": `Build customer loyalty and`,
  "landing.hero.title2": `grow your revenue`,
  "landing.hero.title3": `with Popcard Rewards`,
  "landing.how.subtitle": `All the tools you need to build customer loyalty, on a single platform.`,
  "landing.how.title": `It has never been this simple
to build customer loyalty 💘`,
  "landing.included.badge": `ALSO INCLUDED`,
  "landing.included.ecom.desc": `Connects to Shopify, WooCommerce and WordPress.`,
  "landing.included.ecom.title": `E-commerce integration`,
  "landing.included.loyalty.desc": `Linear cashback, by tiers or by product categories.`,
  "landing.included.loyalty.title": `Loyalty models`,
  "landing.included.multi.desc": `Manage several outlets from a single company profile.`,
  "landing.included.multi.title": `Multi-store`,
  "landing.included.reports.desc": `Receive your key metrics at the frequency you choose.`,
  "landing.included.reports.title": `WhatsApp reports`,
  "landing.receipt.amount": `Amount`,
  "landing.receipt.pointsGranted": `✓ +24 pts granted`,
  "landing.receipt.ticketNo": `Receipt no.`,
  "landing.reels.aria.next": `Next reel`,
  "landing.reels.aria.prev": `Previous reel`,
  "landing.reels.aria.viewReel": `View reel {handle}`,
  "landing.reels.category.beautyCenter": `Beauty center`,
  "landing.reels.category.gameRoom": `Game room`,
  "landing.reels.category.readyToWear": `Ready-to-wear`,
  "landing.reels.category.restaurant": `Restaurant`,
  "landing.reels.category.shoes": `Shoes`,
  "landing.reels.instagram": `See on Instagram →`,
  "landing.reels.subtitle": `Businesses across Morocco — over {count} loyal customers.`,
  "landing.reels.title": `Our partners say it better than we do`,
  "landing.tools.backoffice.desc": `Choose the loyalty program that fits you, track its performance in real time and easily manage your team's access.`,
  "landing.tools.backoffice.title": `Manager Backoffice`,
  "landing.tools.card.desc": `A multi-brand loyalty card, available in seconds via WhatsApp.`,
  "landing.tools.card.title": `Virtual loyalty card`,
  "landing.tools.staff.desc": `Your team activates cards, grants or redeems points, with full traceability.`,
  "landing.tools.staff.title": `Staff App`,
  "landing.tools.support.desc": `Training, support and marketing strategies to build lasting loyalty.`,
  "landing.tools.support.title": `Popcard Rewards support`,
  "landing.trust.badge": `They trust us`,
  "nav.features": `Features`,
  "nav.getStarted": `Get started`,
  "nav.howItWorks": `How it works`,
  "nav.lang.ar": `العربية`,
  "nav.lang.en": `English`,
  "nav.lang.fr": `Français`,
  "nav.menu": `Menu`,
  "nav.popcard": `Popcard`,
  "nav.pricing": `Pricing`,
  "nav.testimonials": `Testimonials`,
  "pricing.badge": `✦ Pricing`,
  "pricing.bill.annuel": `Yearly`,
  "pricing.bill.mensuel": `Monthly`,
  "pricing.bizLabel": `Business type`,
  "pricing.cta.noteActive": `Instant activation · no setup fee`,
  "pricing.cta.noteQuote": `An advisor builds your custom network pricing`,
  "pricing.included.ai": `AI receipt scanning`,
  "pricing.included.card": `Connected loyalty card`,
  "pricing.included.google": `Rewarded Google reviews`,
  "pricing.included.referral": `Referrals & Birthdays`,
  "pricing.included.stats": `Back-office & real-time statistics`,
  "pricing.included.support": `Dedicated guidance & support`,
  "pricing.included.title": `Everything included`,
  "pricing.included.whatsapp": `Unlimited WhatsApp campaigns`,
  "pricing.note.annuel": `i.e. {amount} MAD/month · charged in one payment.`,
  "pricing.note.mensuel": `Billed every month, cancel anytime.`,
  "pricing.pvLabel": `Number of outlets`,
  "pricing.pvTier.11plus": `On quote (11+ outlets)`,
  "pricing.quote": `On quote`,
  "pricing.save.annuel": `2 months free · save {amount} MAD`,
  "pricing.subtitle": `From a single shop to a network of outlets — pick your tier, then your billing rhythm.`,
  "pricing.title": `Clear pricing, whatever your size`,
  "pricing.trust.instant": `Instant activation`,
  "pricing.trust.noCommitment": `No commitment`,
  "pricing.trust.noSetup": `No setup fee`,
  "pricing.unit.annuel": `MAD incl. tax / yr`,
  "pricing.unit.mensuel": `MAD incl. tax / mo`,
  "pricing.whitelabel.desc": `Your brand alone in the customer's wallet, with no other partners in the directory — closed loop.`,
  "pricing.whitelabel.title": `White-label solution`,
  "shared.cta.callAdvisor": `Call an advisor`,
  "shared.cta.chooseOffer": `Choose this plan →`,
  "shared.cta.getDemo": `Get a demo →`,
  "shared.cta.onQuote": `On quote →`,
  "shared.cta.requestQuote": `Request a quote →`,
  "shared.footer.cgv": `Terms`,
  "shared.footer.company": `COMPANY`,
  "shared.footer.contact": `CONTACT`,
  "shared.footer.legal": `Legal notice`,
  "shared.footer.privacy": `Privacy`,
  "shared.footer.product": `PRODUCT`,
  "shared.footer.rights": `© 2025 Popcard. All rights reserved.`,
  "shared.footer.tagline": `The 1st universal loyalty card, 100% made in Morocco 🇲🇦 — no app required.`,
  "shared.loading": `Loading…`,
  "shared.securePayment": `Secure payment`,
  "shared.units.pts": `pts`,
} as const;

// Auto-generated — run: node scripts/build-rv2-messages.mjs
export const arMessages = {
  "backoffice.demo.merchantLocation": `مقهى أطلس · الدار البيضاء`,
  "backoffice.demoView.data": `البيانات`,
  "backoffice.demoView.firstLogin": `أول تسجيل دخول`,
  "backoffice.demoView.title": `عرض تجريبي`,
  "backoffice.header.period": `آخر 7 أيام ▾`,
  "backoffice.kpi.activeMerchants": `التجار النشطون`,
  "backoffice.kpi.delta.activeMerchants": `↑ 6 هذا الشهر`,
  "backoffice.kpi.delta.redemption": `↑ 3,1 نقطة`,
  "backoffice.kpi.delta.repeat": `↑ 5 نقاط`,
  "backoffice.kpi.delta.selfReward": `مسوحات الذكاء الاصطناعي`,
  "backoffice.kpi.delta.transactions": `↑ 12,4٪`,
  "backoffice.kpi.redemption": `معدل الاستبدال`,
  "backoffice.kpi.repeat": `العملاء المتكررون`,
  "backoffice.kpi.selfReward": `المكافأة الذاتية`,
  "backoffice.kpi.transactions": `المعاملات`,
  "backoffice.sidebar.campaigns": `الحملات`,
  "backoffice.sidebar.clients": `العملاء`,
  "backoffice.sidebar.dashboard": `لوحة القيادة`,
  "backoffice.sidebar.rewards": `المكافآت`,
  "backoffice.sidebar.settings": `الإعدادات`,
  "backoffice.sidebar.team": `الفريق`,
  "backoffice.table.amount": `المبلغ`,
  "backoffice.table.client": `العميل`,
  "backoffice.table.date": `التاريخ`,
  "backoffice.table.points": `النقاط`,
  "backoffice.table.recent": `آخر المعاملات`,
  "backoffice.table.type": `النوع`,
  "backoffice.table.type.purchase": `شراء`,
  "backoffice.table.type.referral": `إحالة`,
  "backoffice.table.type.reward": `مكافأة`,
  "backoffice.table.type.selfReward": `المكافأة الذاتية`,
  "backoffice.welcome.cta": `إعداد برنامجي →`,
  "backoffice.welcome.steps.points": `قواعد النقاط`,
  "backoffice.welcome.steps.rewards": `المكافآت`,
  "backoffice.welcome.steps.team": `دعوة الفريق`,
  "backoffice.welcome.subtitle": `أعدّ أول برنامج ولاء في 3 دقائق. نرشدك خطوة بخطوة.`,
  "backoffice.welcome.title": `مرحبًا بك في Popcard Rewards، Café Atlas 👋`,
  "checkout.advisor.noteLabel": `ملاحظة من مستشارك`,
  "checkout.back": `← رجوع`,
  "checkout.billing.address": `العنوان *`,
  "checkout.billing.addressPh": `مثال: 12 شارع محمد الخامس`,
  "checkout.billing.city": `المدينة *`,
  "checkout.billing.cityPh": `مثال: الدار البيضاء`,
  "checkout.billing.continue": `المتابعة إلى الخطة ←`,
  "checkout.billing.email": `البريد الإلكتروني *`,
  "checkout.billing.emailPh": `you@example.com`,
  "checkout.billing.entityCompany": `شركة`,
  "checkout.billing.entityIndividual": `فرد`,
  "checkout.billing.entityType": `هل ترغب في الفوترة كشركة أم كفرد؟`,
  "checkout.billing.firstName": `الاسم الشخصي *`,
  "checkout.billing.ice": `ICE *`,
  "checkout.billing.icePh": `مثال: 001234567000012`,
  "checkout.billing.ifRc": `المعرّف الجبائي / السجل التجاري (اختياري)`,
  "checkout.billing.ifRcPh": `مثال: 123456`,
  "checkout.billing.lastName": `الاسم العائلي *`,
  "checkout.billing.phone": `الهاتف *`,
  "checkout.billing.phonePh": `مثال: 06 12 34 56 78`,
  "checkout.billing.raisonSociale": `الاسم القانوني *`,
  "checkout.billing.raisonSocialePh": `Popcard`,
  "checkout.billing.saving": `جاري الحفظ…`,
  "checkout.billing.subtitle": `تُستخدم هذه المعلومات لإنشاء فواتيرك.`,
  "checkout.billing.title": `معلومات الفوترة`,
  "checkout.billing.zipCode": `الرمز البريدي *`,
  "checkout.billing.zipCodePh": `مثال: 20000`,
  "checkout.continue": `المتابعة ←`,
  "checkout.cta.requestDemo": `طلب عرض توضيحي`,
  "checkout.errors.address": `يرجى إدخال عنوانك.`,
  "checkout.errors.billingSave": `تعذر حفظ معلومات الفوترة.`,
  "checkout.errors.city": `يرجى إدخال مدينتك.`,
  "checkout.errors.contactSales": `لـ 11 نقطة بيع أو أكثر، تواصل مع فريق المبيعات.`,
  "checkout.errors.email": `يرجى إدخال عنوان بريدك الإلكتروني.`,
  "checkout.errors.emailInvalid": `عنوان بريد إلكتروني غير صالح (مثال: name@company.com).`,
  "checkout.errors.firstName": `يرجى إدخال اسمك الشخصي.`,
  "checkout.errors.formBanner": `يرجى تصحيح الحقول المشار إليها أدناه.`,
  "checkout.errors.ice": `يرجى إدخال رقم ICE.`,
  "checkout.errors.ifRc": `يرجى إدخال المعرّف الجبائي / السجل التجاري.`,
  "checkout.errors.invalidLink": `رابط الدفع غير صالح. تواصل مع مستشار Popcard.`,
  "checkout.errors.lastName": `يرجى إدخال اسمك العائلي.`,
  "checkout.errors.leadNotFound": `الطلب غير موجود. تحقق من الرابط المرسل من مستشارك.`,
  "checkout.errors.paymentCancelled": `تم إلغاء الدفع. يمكنك المحاولة مرة أخرى.`,
  "checkout.errors.paymentFailed": `فشل الدفع. يمكنك المحاولة مرة أخرى.`,
  "checkout.errors.paymentInit": `تعذر بدء الدفع. تحقق من إعداد Payzone.`,
  "checkout.errors.paymentPending": `الدفع قيد التأكيد. حدّث الصفحة بعد لحظات.`,
  "checkout.errors.phone": `يرجى إدخال رقم هاتفك.`,
  "checkout.errors.phoneDigits": `يجب أن يحتوي الرقم على أرقام فقط.`,
  "checkout.errors.phoneInvalid": `رقم هاتف غير صالح.`,
  "checkout.errors.planRequired": `يرجى اختيار خطة.`,
  "checkout.errors.planSave": `تعذر حفظ الخطة.`,
  "checkout.errors.raisonSociale": `يرجى إدخال الاسم القانوني.`,
  "checkout.errors.zipCode": `يرجى إدخال الرمز البريدي.`,
  "checkout.hero.default": `أكمل اشتراكك باتباع الخطوات أدناه.`,
  "checkout.hero.greeting": `مرحبًا {name} 👋 تم التحقق من عرضك`,
  "checkout.hero.withAdvisor": `أعد {advisor} عرضك. أكمل اشتراكك باتباع الخطوات أدناه.`,
  "checkout.pay": `🔒 ادفع وفعّل حسابي`,
  "checkout.payAmount": `ادفع {amount} درهم ←`,
  "checkout.payment.ackRequired": `حدّد المربع أعلاه للمتابعة إلى صفحة الدفع.`,
  "checkout.payment.autoRenew.charge": `يُخصم المبلغ أعلاه تلقائيًا في كل موعد استحقاق، في تاريخ الذكرى السنوية.`,
  "checkout.payment.autoRenew.control": `تبقى مسيطرًا: ألغِ في أي وقت من لوحة التحكم — بدون رسوم أو مبرر.`,
  "checkout.payment.autoRenew.partnerPrefix": `تتم إدخال البطاقة لدى شريكنا في الدفع`,
  "checkout.payment.autoRenew.partnerSuffix": `؛ Popcard Rewards لا يصل أبدًا إلى بياناتك البنكية.`,
  "checkout.payment.autoRenew.title": `🔁 اشتراك بتجديد تلقائي`,
  "checkout.payment.confirm.subtitle": `راجع الملخص، واقبل الشروط، ثم أكد للانتقال إلى صفحة الدفع الآمنة لشريكنا.`,
  "checkout.payment.confirm.title": `تأكيد اشتراكك`,
  "checkout.payment.confirming": `جاري تأكيد الدفع…`,
  "checkout.payment.installation": `التركيب`,
  "checkout.payment.installationFree": `مجانًا`,
  "checkout.payment.recap": `الملخص`,
  "checkout.payment.recurrence": `🔁 ثم {amount} {every}، ابتداءً من {date}. قابل للإلغاء في أي وقت.`,
  "checkout.payment.redirecting": `جاري التوجيه…`,
  "checkout.payment.securedPrefix": `🔒 مؤمَّن بواسطة`,
  "checkout.payment.securedSuffix": `· فاتورة تلقائية`,
  "checkout.payment.terms.cgv": `الشروط العامة للبيع`,
  "checkout.payment.terms.mid": `وأفوض صراحةً التجديد التلقائي لاشتراكي`,
  "checkout.payment.terms.prefix": `أقر بأنني اطلعت على`,
  "checkout.payment.terms.suffix": `وفق الشروط المذكورة أعلاه، حتى الإلغاء.`,
  "checkout.payment.title": `دفع آمن`,
  "checkout.payment.totalToday": `الإجمالي اليوم`,
  "checkout.plan.bestOffer": `⭐ أفضل عرض`,
  "checkout.plan.bizLabel": `نوع النشاط`,
  "checkout.plan.card.annualBenefit": `✓ شهران مجانًا`,
  "checkout.plan.card.annualSub": `أي {amount} درهم/شهر`,
  "checkout.plan.card.monthlyFlex": `مرونة كاملة`,
  "checkout.plan.circuitLabel": `الدائرة`,
  "checkout.plan.closedCircuit": `دائرة مغلقة`,
  "checkout.plan.continuePayment": `المتابعة إلى الدفع ←`,
  "checkout.plan.dueToday": `المستحق اليوم (شامل الضريبة)`,
  "checkout.plan.label.monthly": `شهري`,
  "checkout.plan.label.yearly": `سنوي`,
  "checkout.plan.loading": `جاري تحميل الخطط…`,
  "checkout.plan.networkQuote.desc": `بعد 10 نقاط بيع، يُعدّ مستشارك عرضًا يناسب حجمك. سيُضاف المبلغ الدقيق هنا قبل الدفع.`,
  "checkout.plan.networkQuote.title": `تسعير الشبكة حسب العرض`,
  "checkout.plan.offerApplied": `تم تطبيق العرض التجاري على هذه الشريحة من نقاط البيع.`,
  "checkout.plan.openCircuit": `دائرة مفتوحة`,
  "checkout.plan.publicPricing": `الأسعار العامة لهذه الشريحة. عد إلى {tier} للعثور على العرض المتفاوض عليه.`,
  "checkout.plan.pvEditable": `✓ قابل للتعديل في هذه الخطوة`,
  "checkout.plan.pvLabel": `عدد نقاط البيع`,
  "checkout.plan.recur.monthly": `كل شهر`,
  "checkout.plan.recur.yearly": `كل سنة`,
  "checkout.plan.setupFee": `رسوم التركيب`,
  "checkout.plan.setupFree": `مجاني`,
  "checkout.plan.subscription": `اشتراك {plan}`,
  "checkout.plan.subtitle": `هذا هو الاشتراك الذي اخترته أو اتفقت عليه مع مستشارك. يمكنك تغييره في أي وقت.`,
  "checkout.plan.surDevis": `حسب عرض السعر`,
  "checkout.plan.title": `باقتك`,
  "checkout.plan.unit.perMonth": `/شهر`,
  "checkout.plan.unit.perYear": `/سنة`,
  "checkout.steps.access": `الوصول`,
  "checkout.steps.billing": `الفوترة`,
  "checkout.steps.payment": `الدفع`,
  "checkout.steps.plan": `الباقة`,
  "checkout.success.badge": `تم تأكيد الدفع`,
  "checkout.success.cta": `إنشاء وصولي →`,
  "checkout.success.manageHint": `يمكنك إدارة اشتراكك أو إلغاؤه وتحديث بطاقتك في أي وقت من لوحة التحكم.`,
  "checkout.success.recap.invoiceLabel": `الفاتورة`,
  "checkout.success.recap.invoiceValue": `متاحة في تبويب الفوترة في لوحة التحكم`,
  "checkout.success.recap.nextChargeLabel": `الاقتطاع القادم`,
  "checkout.success.recap.nextChargeValue": `{amount} في {date}`,
  "checkout.success.recap.planLabel": `الباقة`,
  "checkout.success.subtitle": `تبقّت خطوة واحدة: أنشئ بيانات الدخول الخاصة بك.`,
  "checkout.success.title": `برنامج ولائك جاهز 🚀`,
  "commercants.badge": `للتجار 🇲🇦`,
  "commercants.biz.label": `🏪 نشاطك التجاري هو… *`,
  "commercants.biz.mixte.desc": `كلا القناتين معًا.`,
  "commercants.biz.mixte.title": `فعلي + إلكتروني`,
  "commercants.biz.online.desc": `Shopify, WooCommerce, WordPress…`,
  "commercants.biz.online.title": `متجر إلكتروني`,
  "commercants.biz.physique.desc": `متجر، مطعم، صالون…`,
  "commercants.biz.physique.title": `متجر فعلي`,
  "commercants.city.empty": `لم يُعثر على المدينة — اتصل بنا وسنتكفّل بكل شيء.`,
  "commercants.city.hint": `اختر مدينتك لرؤية صيغ العرض التوضيحي المتاحة قربك.`,
  "commercants.city.label": `📍 في أي مدينة؟ *`,
  "commercants.city.onsite": `🏬 في الموقع`,
  "commercants.city.otherLabel": `حدّد مدينتك *`,
  "commercants.city.otherPlaceholder": `مثال: الجديدة`,
  "commercants.city.placeholder": `ابحث عن مدينتك…`,
  "commercants.confirmation.backHome": `العودة إلى الرئيسية`,
  "commercants.confirmation.callback": `نتصل بك عادةً في أقل من ساعة عمل! ⚡☎️`,
  "commercants.confirmation.card.backoffice.desc": `يُفعَّل برنامج الولاء الخاص بك فورًا.`,
  "commercants.confirmation.card.backoffice.title": `الوصول إلى لوحة التحكم`,
  "commercants.confirmation.card.demo.desc": `نقدم لك الحل المناسب لتجارتك.`,
  "commercants.confirmation.card.demo.title": `عرض توضيحي`,
  "commercants.confirmation.card.payment.desc": `رابط واحد للدفع عبر الإنترنت بثقة.`,
  "commercants.confirmation.card.payment.title": `دفع آمن`,
  "commercants.confirmation.demoMode.online": `عرض عبر الإنترنت`,
  "commercants.confirmation.demoMode.place": `عرض في الموقع`,
  "commercants.confirmation.fields.bizType": `نوع النشاط`,
  "commercants.confirmation.fields.businessLink": `رابط النشاط`,
  "commercants.confirmation.fields.businessStatus": `حالة النشاط`,
  "commercants.confirmation.fields.city": `المدينة`,
  "commercants.confirmation.fields.company": `الشركة`,
  "commercants.confirmation.fields.email": `البريد الإلكتروني`,
  "commercants.confirmation.fields.firstName": `الاسم الشخصي`,
  "commercants.confirmation.fields.lastName": `الاسم العائلي`,
  "commercants.confirmation.fields.phone": `الهاتف`,
  "commercants.confirmation.fields.plan": `الاشتراك المطلوب`,
  "commercants.confirmation.fields.pv": `نقاط البيع`,
  "commercants.confirmation.followUs": `في انتظار عرضك التوضيحي، تابعنا 👀`,
  "commercants.confirmation.journey.step1": `يتواصل معك مستشار للتحقق من عرضك التوضيحي.`,
  "commercants.confirmation.journey.step2": `تختار خطتك وإيقاع الفوترة.`,
  "commercants.confirmation.journey.step3": `يبدأ الإعداد — يصبح برنامجك جاهزًا.`,
  "commercants.confirmation.journey.steps": `3 خطوات`,
  "commercants.confirmation.journey.title": `وماذا بعد؟`,
  "commercants.confirmation.newRequest": `طلب جديد`,
  "commercants.confirmation.recap": `ملخص`,
  "commercants.confirmation.recapHeader": `ملخص طلبك`,
  "commercants.confirmation.social": `اكتشف ما نبنيه يوميًا والمتاجر المغربية التي تبني ولاءها بالفعل مع Popcard Rewards.`,
  "commercants.confirmation.socialProof": `+150 متجرًا أُقنعت بالفعل · شهادات جديدة كل أسبوع`,
  "commercants.confirmation.subtitle": `سيتواصل معك فريقنا خلال 24 ساعة لتأكيد موعد العرض التوضيحي.`,
  "commercants.confirmation.title": `تم استلام طلبك بنجاح`,
  "commercants.demo.noOnsite.hint": `العرض التوضيحي في الموقع غير متاح في {city} بعد. لا تقلق — العرض عبر الإنترنت كامل بنفس القدر ولا يستغرق سوى 30 دقيقة.`,
  "commercants.demo.online.desc": `عبر مكالمة فيديو (Zoom أو Google Meet) من متجرك. سريع — 30 دقيقة.`,
  "commercants.demo.online.title": `عرض عبر الإنترنت`,
  "commercants.demo.onlineOnly.desc": `عبر مكالمة فيديو (Zoom أو Google Meet)، من تجارتك في {city}. سريعة — 30 دقيقة.`,
  "commercants.demo.onlineOnly.title": `عرض عبر الإنترنت`,
  "commercants.demo.onlineShop.hint": `متجر إلكتروني: نربط Popcard Rewards بموقعك على Shopify أو WooCommerce أو WordPress. يتم العرض عبر مكالمة فيديو — سريع وكامل، 30 دقيقة.`,
  "commercants.demo.onsite.badge": `🎉 عرض في الموقع متاح في {city}`,
  "commercants.demo.place.desc": `يزورك مندوب في {city}.`,
  "commercants.demo.place.title": `عرض في الموقع`,
  "commercants.demo.subtitle": `مجانية ودون التزام. أخبرنا أولاً بنوع نشاطك التجاري.`,
  "commercants.demo.title": `احجز عرضك التوضيحي`,
  "commercants.errors.biz": `يرجى تحديد نوع نشاطك التجاري.`,
  "commercants.errors.businessStatus": `يرجى تحديد حالة نشاطك.`,
  "commercants.errors.city": `يرجى اختيار مدينتك من القائمة أعلى الصفحة.`,
  "commercants.errors.cityDetail": `يرجى تحديد مدينتك.`,
  "commercants.errors.company": `يرجى إدخال اسم شركتك.`,
  "commercants.errors.demoMode": `يرجى اختيار نوع العرض التوضيحي.`,
  "commercants.errors.email": `يرجى إدخال عنوان بريدك الإلكتروني.`,
  "commercants.errors.emailInvalid": `عنوان بريد إلكتروني غير صالح (مثال: name@company.ma).`,
  "commercants.errors.firstName": `يرجى إدخال اسمك الشخصي.`,
  "commercants.errors.formBanner": `يرجى تصحيح الحقول المشار إليها أدناه.`,
  "commercants.errors.generic": `حدث خطأ. يرجى المحاولة مرة أخرى.`,
  "commercants.errors.lastName": `يرجى إدخال اسمك العائلي.`,
  "commercants.errors.phone": `يرجى إدخال رقم هاتفك.`,
  "commercants.errors.phoneDigits": `يجب أن يحتوي الرقم على أرقام فقط.`,
  "commercants.errors.phoneInvalid": `رقم هاتف غير صالح.`,
  "commercants.errors.plan": `يرجى اختيار نوع الاشتراك.`,
  "commercants.features.communicate.desc": `أرسل حملات مستهدفة عبر Popcard Rewards وابقَ حاضرًا لدى عملائك في الوقت المناسب.`,
  "commercants.features.communicate.title": `تواصل مباشرة`,
  "commercants.features.community.desc": `أطلق المسابقات، وفعّل الإحالة، وحوّل عملاءك الراضين إلى محركات للنمو.`,
  "commercants.features.community.title": `حفّز مجتمعك`,
  "commercants.features.loyalty.desc": `كافئ كل عملية شراء بالنقاط أو الهدايا أو الاسترداد النقدي، وشجّع عملاءك على العودة أكثر.`,
  "commercants.features.loyalty.title": `اكسب ولاء عملائك`,
  "commercants.features.pilot.desc": `تابع مبيعاتك وعملاءك الأوفياء وحملاتك وأداء برنامجك من لوحة تحكم متكاملة.`,
  "commercants.features.pilot.title": `أدِر نشاطك`,
  "commercants.features.title": `اكتشف مزايا Popcard Rewards`,
  "commercants.form.businessLink": `رابط نشاطك (موقع، صفحة إنستغرام، أو غير ذلك)`,
  "commercants.form.businessLinkPh": `https://…`,
  "commercants.form.businessStatus": `حالة النشاط *`,
  "commercants.form.businessStatus.established": `قائم`,
  "commercants.form.businessStatus.noActivity": `بدون نشاط قائم`,
  "commercants.form.businessStatus.placeholder": `اختر…`,
  "commercants.form.businessStatus.preLaunch": `قيد التحضير للإطلاق`,
  "commercants.form.city": `المدينة *`,
  "commercants.form.cityPh": `محددة أعلاه`,
  "commercants.form.company": `اسم الشركة *`,
  "commercants.form.companyPh": `مثال: Café Atlas`,
  "commercants.form.email": `البريد الإلكتروني *`,
  "commercants.form.emailPh": `you@company.ma`,
  "commercants.form.firstName": `الاسم الشخصي *`,
  "commercants.form.firstNamePh": `مثال: Karim`,
  "commercants.form.footer": `لا يتاح اختيار الباقة والتهيئة إلا بعد اعتماد عرضك من المندوب المكلّف.`,
  "commercants.form.lastName": `الاسم العائلي *`,
  "commercants.form.lastNamePh": `مثال: Bennani`,
  "commercants.form.phone": `الهاتف *`,
  "commercants.form.phonePh": `6 00 00 00 00`,
  "commercants.form.plan": `نوع الاشتراك المطلوب *`,
  "commercants.form.plan.placeholder": `اختر…`,
  "commercants.form.planAnnuel": `سنوي (وفّر شهرين)`,
  "commercants.form.planMensuel": `شهري`,
  "commercants.form.pv": `عدد نقاط البيع *`,
  "commercants.form.pv1": `نقطة بيع واحدة`,
  "commercants.form.pv11": `11 نقطة بيع أو أكثر`,
  "commercants.form.pv23": `2 إلى 3 نقاط بيع`,
  "commercants.form.pv46": `4 إلى 6 نقاط بيع`,
  "commercants.form.pv710": `7 إلى 10 نقاط بيع`,
  "commercants.form.pvWhite": `حسب عرض السعر (علامة بيضاء)`,
  "commercants.form.submit": `أكّد طلب العرض التوضيحي`,
  "commercants.form.submitting": `جارٍ الإرسال…`,
  "commercants.next.step1": `تحجز عرضك التوضيحي، مجانًا ودون التزام.`,
  "commercants.next.step2": `يعتمد المندوب المكلّف عرضك واحتياجاتك.`,
  "commercants.next.step3": `تختار اشتراكك المتكرر، ثم يبدأ التهيئة.`,
  "commercants.next.title": `كيف تسير الأمور بعد ذلك؟`,
  "commercants.subtitle": `مجموعة أدوات بسعر مخفّض لبناء ولاء دائم لعملائك وزيادة إيراداتك المتكررة.`,
  "commercants.title": `نمو متجرك يبدأ من عملائك.`,
  "creationLogin.advisor.footer": `لا إجراء إضافي — Abdelouahab سيتواصل معك.`,
  "creationLogin.advisor.label": `مستشارك في Popcard Rewards`,
  "creationLogin.advisor.step1": `سيتصل بك لتحديد موعد مكالمة فيديو.`,
  "creationLogin.advisor.step2": `معًا، ستنهيان الإعداد وتكوين نظامك.`,
  "creationLogin.advisor.step3": `سيدرّب فريقك على استخدام الحل يوميًا.`,
  "creationLogin.advisor.training.desc": `بمجرد إنهاء إنشاء وصولك، سيتم إبلاغ Abdelouahab وسيتصل بك لتحديد موعد.`,
  "creationLogin.advisor.training.title": `التركيب وتدريب الفريق`,
  "creationLogin.backToCheckout": `العودة إلى الدفع`,
  "creationLogin.errors.accountExists": `يوجد حساب بالفعل لهذا الطلب. سجّل الدخول إلى لوحة التحكم.`,
  "creationLogin.errors.businessRequired": `اسم التجارة مطلوب.`,
  "creationLogin.errors.createFailed": `تعذر إنشاء الحساب.`,
  "creationLogin.errors.handoffFailed": `تم إنشاء الحساب، لكن تسجيل الدخول التلقائي فشل. سجّل الدخول يدويًا إلى لوحة التحكم.`,
  "creationLogin.errors.invalidLink": `رابط غير صالح. عد من خطوة الدفع.`,
  "creationLogin.errors.leadNotFound": `الطلب غير موجود.`,
  "creationLogin.errors.passwordLength": `يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل.`,
  "creationLogin.errors.passwordMismatch": `كلمتا المرور غير متطابقتين.`,
  "creationLogin.errors.paymentRequired": `يجب تأكيد الدفع قبل إنشاء وصولك.`,
  "creationLogin.errors.termsRequired": `يجب قبول الشروط العامة للبيع.`,
  "creationLogin.form.businessName": `اسم التجارة *`,
  "creationLogin.form.businessNameHint": `سيكون هذا الاسم المعروض لتجارتك عبر Popcard Rewards`,
  "creationLogin.form.businessNamePh": `مثال: Café Atlas`,
  "creationLogin.form.confirmPassword": `تأكيد كلمة المرور *`,
  "creationLogin.form.email": `البريد الإلكتروني *`,
  "creationLogin.form.legalEntity": `الكيان القانوني`,
  "creationLogin.form.password": `كلمة المرور *`,
  "creationLogin.form.submitting": `جاري الإنشاء…`,
  "creationLogin.form.termsCgv": `الشروط`,
  "creationLogin.form.termsPrefix": `أوافق على`,
  "creationLogin.form.termsSuffix": `وسياسة الخصوصية.`,
  "creationLogin.loginBackoffice": `تسجيل الدخول إلى لوحة التحكم`,
  "creationLogin.paymentConfirmed": `✓ تم تأكيد الدفع`,
  "creationLogin.selfManage": `تدير بيانات دخولك بنفسك.`,
  "creationLogin.submit.accessBackoffice": `الذهاب إلى لوحة تحكمي →`,
  "creationLogin.subtitle": `مرحبًا بك في Popcard Rewards. تبقّت خطوة واحدة: أنشئ بيانات الدخول.`,
  "creationLogin.title": `أنشئ وصولك`,
  "landing.ambassadors.badge": `شراكة مصمّمة خصيصًا`,
  "landing.ambassadors.circuit.desc": `كن مرئيًا على شبكة Popcard Rewards أو قدم تجربة مخصصة.`,
  "landing.ambassadors.circuit.title": `دائرة مفتوحة أو مغلقة`,
  "landing.ambassadors.nfc.desc": `حامل على الطاولة، نقرة واحدة، تم. التسجيل في ثوانٍ.`,
  "landing.ambassadors.nfc.title": `تسجيل عبر NFC / QR`,
  "landing.ambassadors.referral.desc": `يدعو عملاؤك أصدقاءهم من ملفهم الشخصي.`,
  "landing.ambassadors.referral.title": `إحالة مبسّطة`,
  "landing.ambassadors.subtitle": `نُنشئ معك نظامًا يبني الولاء ويوسّع قاعدة عملائك ويزيد إيراداتك المتكررة.`,
  "landing.ambassadors.title": `عملاؤك،
سفراؤك المستقبليون`,
  "landing.ambassadors.wallet.desc": `مساحة ولاء مخصصة لكل علامة، مجمعة في ملف عميل واحد.`,
  "landing.ambassadors.wallet.title": `محفظة لكل علامة`,
  "landing.engagement.badge": `✦ جديد · التسويق والنمو`,
  "landing.engagement.contests.check1": `شروط حسب اختيارك: نموذج، شراء، إحالة…`,
  "landing.engagement.contests.check2": `جوائز متنوعة: نقاط، هدايا، تخفيضات، مزايا`,
  "landing.engagement.contests.check3": `متابعة المشاركات والفائزين والأداء`,
  "landing.engagement.contests.cta": `أنشئ لعبة ←`,
  "landing.engagement.contests.desc": `أطلق سحوبات وتحديات ومكافآت فورية لتحفيز مجتمعك.`,
  "landing.engagement.contests.heading": `حملات تفاعلية في دقائق`,
  "landing.engagement.contests.title": `مسابقات`,
  "landing.engagement.mock.campaignTitle": `حملة واتساب جديدة`,
  "landing.engagement.mock.contacts": `جهات الاتصال`,
  "landing.engagement.mock.contactsCount": `1,240 جهة اتصال`,
  "landing.engagement.mock.contestLabel": `مسابقة`,
  "landing.engagement.mock.contestTitle": `اربح عشاءً لشخصين 🍽️`,
  "landing.engagement.mock.daysLeft": `· تبقّى 12 يومًا`,
  "landing.engagement.mock.messagePrefix": `اشتقنا إليك! 🎁 استفد من`,
  "landing.engagement.mock.messageSuffix": `في زيارتك القادمة إلى Café Atlas. نراك قريبًا!`,
  "landing.engagement.mock.openRate": `معدل الفتح`,
  "landing.engagement.mock.participate": `أشارك`,
  "landing.engagement.mock.pointsOffer": `50 نقطة مجانية`,
  "landing.engagement.mock.prize1.label": `عشاء فاخر لشخصين`,
  "landing.engagement.mock.prize1.rank": `الجائزة الأولى`,
  "landing.engagement.mock.prize2.label": `برانش لشخصين`,
  "landing.engagement.mock.prize2.rank": `الجائزة الثانية`,
  "landing.engagement.mock.prize3.label": `100 نقطة ولاء مجانية`,
  "landing.engagement.mock.prize3.rank": `الجائزة الثالثة`,
  "landing.engagement.mock.prizesTitle": `🎁 جوائز للفوز`,
  "landing.engagement.mock.revenue": `من العملاء العائدين`,
  "landing.engagement.mock.scheduled": `رسائل مجدولة من رقم Popcard Rewards أو رقمك`,
  "landing.engagement.mock.scheduledBadge": `مجدولة · الثلاثاء 14:00`,
  "landing.engagement.mock.winners": `3 فائزين`,
  "landing.engagement.poweredBy": `مدعوم من`,
  "landing.engagement.subtitle": `أداتان جديدتان تُداران من لوحة التحكم، دون مغادرة Popcard Rewards.`,
  "landing.engagement.title": `حفّز، أشرك، ووسّع قاعدة عملائك`,
  "landing.engagement.whatsapp.check1": `استهداف حسب الشريحة: خاملون، كبار العملاء، جدد…`,
  "landing.engagement.whatsapp.check3": `متابعة الفتح والردود والتحويلات`,
  "landing.engagement.whatsapp.cta": `جدولة حملة ←`,
  "landing.engagement.whatsapp.desc": `جدّول رسائل مستهدفة وأتمت متابعة عملائك من Popcard Rewards.`,
  "landing.engagement.whatsapp.heading": `خاطب قاعدة عملائك بالكامل بنقرة واحدة`,
  "landing.engagement.whatsapp.title": `الحملات WhatsApp`,
  "landing.features.badge": `✦ مدعوم بالذكاء الاصطناعي`,
  "landing.features.birthday.desc": `رسائل ومكافآت تلقائية.`,
  "landing.features.birthday.title": `عيد الميلاد والإحالة`,
  "landing.features.google.desc": `يساعد الذكاء الاصطناعي في كتابة المراجعة ويمنح المكافأة.`,
  "landing.features.google.title": `تقييمات جوجل مُكافأة`,
  "landing.features.receipt.badge": `🧾 قراءة ذكية للإيصال`,
  "landing.features.receipt.desc": `يُكتشف المبلغ والتاريخ ورقم الإيصال ويُتحقق منها تلقائيًا دون إدخال يدوي.`,
  "landing.features.receipt.title": `الذكاء الاصطناعي يقرأ الإيصال`,
  "landing.features.selfReward.desc": `يمسح العميل إيصاله من ملفه الشخصي.`,
  "landing.features.selfReward.title": `المكافأة الذاتية`,
  "landing.features.subtitle": `دون تحميل ودون تعقيد. كل شيء يبدأ على واتساب.`,
  "landing.features.title": `الذكاء الذي يكافئ،
تلقائيًا`,
  "landing.features.whatsapp.desc": `التسجيل بنقرة واحدة على واتساب. والتطبيق؟ يأتي من تلقاء نفسه حين يتعلّق به العميل.`,
  "landing.features.whatsapp.title": `بدون تطبيق`,
  "landing.finalCta.subtitle": `ابتداءً من 250 درهم/شهر — تفعيل فوري، 100٪ صنع في 🇲🇦.`,
  "landing.finalCta.title": `حوّل برنامج
الولاء إلى نجاح!`,
  "landing.hero.badge": `معتمدة من +150 شريكًا في المغرب 🇲🇦`,
  "landing.hero.bullet.instantSignup": `تم تسجيل العميل فورًا`,
  "landing.hero.bullet.poweredByAi": `مدعوم بالذكاء الاصطناعي`,
  "landing.hero.bullet.viaWhatsapp": `100٪ عبر واتساب`,
  "landing.hero.desc": `امنح نقاط ولاء لعملائك واجعلهم يعودون أكثر بفضل حل مغربي 100٪ 🇲🇦`,
  "landing.hero.desc.automate": `أتمت`,
  "landing.hero.desc.grow": `زد من`,
  "landing.hero.desc.retain": `اكسب ولاء`,
  "landing.hero.desc.suffix": `إيراداتك المتكررة.`,
  "landing.hero.fromPrice": `ابتداءً من`,
  "landing.hero.perMonth": `/شهر`,
  "landing.hero.phone.cardSubtitle": `اعرض رمز QR لدى شركائنا`,
  "landing.hero.phone.cardTitle": `بطاقة الولاء الرقمية الخاصة بي`,
  "landing.hero.phone.myWallets": `محافظي`,
  "landing.hero.phone.pointsBalance": `رصيد النقاط`,
  "landing.hero.phone.tag.home": `المنزل والتجهيز…`,
  "landing.hero.phone.tag.leisure": `الترفيه`,
  "landing.hero.phone.tag.wellness": `العناية والرفاهية …`,
  "landing.hero.title1": `اكسب ولاء عملائك و`,
  "landing.hero.title2": `زد إيراداتك`,
  "landing.hero.title3": `بفضل Popcard Rewards`,
  "landing.how.subtitle": `كل الأدوات التي تحتاجها لكسب ولاء عملائك، على منصة واحدة.`,
  "landing.how.title": `لم يكن كسب ولاء العملاء
بهذه السهولة من قبل 💘`,
  "landing.included.badge": `وأيضًا، مشمول`,
  "landing.included.ecom.desc": `يتصل بـ Shopify وWooCommerce وWordPress.`,
  "landing.included.ecom.title": `تكامل التجارة الإلكترونية`,
  "landing.included.loyalty.desc": `استرداد نقدي خطي، بالشرائح أو حسب فئات المنتجات.`,
  "landing.included.loyalty.title": `نماذج الولاء`,
  "landing.included.multi.desc": `أدِر عدة نقاط بيع من ملف شركة واحد.`,
  "landing.included.multi.title": `متعدد المتاجر`,
  "landing.included.reports.desc": `استلم مؤشراتك الرئيسية بالتكرار الذي تختاره.`,
  "landing.included.reports.title": `تقارير واتساب`,
  "landing.receipt.amount": `المبلغ`,
  "landing.receipt.pointsGranted": `✓ مُنحت +24 نقطة`,
  "landing.receipt.ticketNo": `إيصال رقم`,
  "landing.reels.aria.next": `الريل التالي`,
  "landing.reels.aria.prev": `الريل السابق`,
  "landing.reels.aria.viewReel": `مشاهدة الريل {handle}`,
  "landing.reels.category.beautyCenter": `مركز تجميل`,
  "landing.reels.category.gameRoom": `قاعة ألعاب`,
  "landing.reels.category.readyToWear": `ملابس جاهزة`,
  "landing.reels.category.restaurant": `مطعم`,
  "landing.reels.category.shoes": `أحذية`,
  "landing.reels.instagram": `شاهد على إنستغرام →`,
  "landing.reels.subtitle": `تجارات من جميع أنحاء المغرب — أكثر من {count} عميل وفي.`,
  "landing.reels.title": `شركاؤنا يتحدثون عنّا أفضل منّا`,
  "landing.tools.backoffice.desc": `اختر برنامج الولاء الذي يناسبك، وتابع أداءه لحظيًا، وأدِر صلاحيات فرقك بسهولة.`,
  "landing.tools.backoffice.title": `لوحة تحكم المدير`,
  "landing.tools.card.desc": `بطاقة ولاء متعددة العلامات، متاحة في ثوانٍ عبر واتساب.`,
  "landing.tools.card.title": `بطاقة ولاء رقمية`,
  "landing.tools.staff.desc": `يفعّل فريقك البطاقات ويمنح أو يستبدل النقاط بتتبّع كامل.`,
  "landing.tools.staff.title": `تطبيق الفريق`,
  "landing.tools.support.desc": `تدريب ودعم واستراتيجيات تسويقية لبناء ولاء دائم.`,
  "landing.tools.support.title": `مرافقة Popcard Rewards`,
  "landing.trust.badge": `يثقون بنا`,
  "nav.features": `المزايا`,
  "nav.getStarted": `ابدأ الآن`,
  "nav.howItWorks": `كيف يعمل`,
  "nav.lang.ar": `العربية`,
  "nav.lang.en": `English`,
  "nav.lang.fr": `Français`,
  "nav.menu": `القائمة`,
  "nav.popcard": `Popcard`,
  "nav.pricing": `الأسعار`,
  "nav.testimonials": `الشهادات`,
  "pricing.badge": `✦ الأسعار`,
  "pricing.bill.annuel": `سنوي`,
  "pricing.bill.mensuel": `شهري`,
  "pricing.bizLabel": `نوع النشاط`,
  "pricing.cta.noteActive": `تفعيل فوري · دون رسوم تركيب`,
  "pricing.cta.noteQuote": `يُعدّ لك مستشار تسعيرة شبكة مخصصة`,
  "pricing.included.ai": `قراءة الإيصالات بالذكاء الاصطناعي`,
  "pricing.included.card": `بطاقة ولاء متصلة`,
  "pricing.included.google": `مراجعات Google مكافأة`,
  "pricing.included.referral": `الإحالة وأعياد الميلاد`,
  "pricing.included.stats": `لوحة تحكم وإحصاءات لحظية`,
  "pricing.included.support": `مرافقة ودعم مخصص`,
  "pricing.included.title": `كل شيء مشمول`,
  "pricing.included.whatsapp": `حملات واتساب غير محدودة`,
  "pricing.note.annuel": `أي {amount} درهم/شهر · يُخصم دفعة واحدة.`,
  "pricing.note.mensuel": `يُفوتر كل شهر، قابل للإلغاء في أي وقت.`,
  "pricing.pvLabel": `عدد نقاط البيع`,
  "pricing.pvTier.11plus": `عرض سعر (11+ نقطة بيع)`,
  "pricing.quote": `حسب عرض السعر`,
  "pricing.save.annuel": `شهران مجانيان · وفّر {amount} درهم`,
  "pricing.subtitle": `من متجر واحد إلى شبكة نقاط بيع — اختر فئتك ثم وتيرة الفوترة.`,
  "pricing.title": `سعر واضح مهما كان حجمك`,
  "pricing.trust.instant": `تفعيل فوري`,
  "pricing.trust.noCommitment": `دون التزام`,
  "pricing.trust.noSetup": `دون رسوم تركيب`,
  "pricing.unit.annuel": `درهم شامل الضريبة / سنة`,
  "pricing.unit.mensuel": `درهم شامل الضريبة / شهر`,
  "pricing.whitelabel.desc": `علامتك وحدها في محفظة العميل، دون شركاء آخرين في الدليل — دائرة مغلقة.`,
  "pricing.whitelabel.title": `حل بعلامة بيضاء`,
  "shared.cta.callAdvisor": `اتصل بمستشار`,
  "shared.cta.chooseOffer": `اختر هذا العرض →`,
  "shared.cta.getDemo": `احصل على عرض توضيحي →`,
  "shared.cta.onQuote": `حسب عرض السعر →`,
  "shared.cta.requestQuote": `اطلب عرض سعر →`,
  "shared.footer.cgv": `الشروط`,
  "shared.footer.company": `الشركة`,
  "shared.footer.contact": `اتصل بنا`,
  "shared.footer.legal": `إشعار قانوني`,
  "shared.footer.privacy": `الخصوصية`,
  "shared.footer.product": `المنتج`,
  "shared.footer.rights": `© 2025 Popcard. جميع الحقوق محفوظة.`,
  "shared.footer.tagline": `أول بطاقة ولاء شاملة، 100٪ صنع في المغرب 🇲🇦 — دون تطبيق.`,
  "shared.loading": `جاري التحميل…`,
  "shared.securePayment": `دفع آمن`,
  "shared.units.pts": `نقطة`,
} as const;
